import { c as createCommonjsModule, a as commonjsGlobal } from './_commonjsHelpers-471920d6.js';
import jsx_runtime_1 from 'react/jsx-runtime';
import React from 'react';

var byteLength_1 = byteLength;
var toByteArray_1 = toByteArray;
var fromByteArray_1 = fromByteArray;

var lookup = [];
var revLookup = [];
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i];
  revLookup[code.charCodeAt(i)] = i;
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62;
revLookup['_'.charCodeAt(0)] = 63;

function getLens (b64) {
  var len = b64.length;

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=');
  if (validLen === -1) validLen = len;

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4);

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64);
  var validLen = lens[0];
  var placeHoldersLen = lens[1];
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp;
  var lens = getLens(b64);
  var validLen = lens[0];
  var placeHoldersLen = lens[1];

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));

  var curByte = 0;

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen;

  var i;
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)];
    arr[curByte++] = (tmp >> 16) & 0xFF;
    arr[curByte++] = (tmp >> 8) & 0xFF;
    arr[curByte++] = tmp & 0xFF;
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4);
    arr[curByte++] = tmp & 0xFF;
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2);
    arr[curByte++] = (tmp >> 8) & 0xFF;
    arr[curByte++] = tmp & 0xFF;
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp;
  var output = [];
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF);
    output.push(tripletToBase64(tmp));
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp;
  var len = uint8.length;
  var extraBytes = len % 3; // if we have 1 byte left, pad 2 bytes
  var parts = [];
  var maxChunkLength = 16383; // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)));
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1];
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    );
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1];
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    );
  }

  return parts.join('')
}

var base64Js = {
	byteLength: byteLength_1,
	toByteArray: toByteArray_1,
	fromByteArray: fromByteArray_1
};

var errors = createCommonjsModule(function (module, exports) {
/*
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License. You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under the
 * License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppAuthError = void 0;
/**
 * Represents the AppAuthError type.
 */
var AppAuthError = /** @class */ (function () {
    function AppAuthError(message, extras) {
        this.message = message;
        this.extras = extras;
    }
    return AppAuthError;
}());
exports.AppAuthError = AppAuthError;

});

var crypto_utils = createCommonjsModule(function (module, exports) {
/*
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License. You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under the
 * License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultCrypto = exports.textEncodeLite = exports.urlSafe = exports.bufferToString = void 0;


var HAS_CRYPTO = typeof window !== 'undefined' && !!window.crypto;
var HAS_SUBTLE_CRYPTO = HAS_CRYPTO && !!window.crypto.subtle;
var CHARSET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
function bufferToString(buffer) {
    var state = [];
    for (var i = 0; i < buffer.byteLength; i += 1) {
        var index = buffer[i] % CHARSET.length;
        state.push(CHARSET[index]);
    }
    return state.join('');
}
exports.bufferToString = bufferToString;
function urlSafe(buffer) {
    var encoded = base64Js.fromByteArray(new Uint8Array(buffer));
    return encoded.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
}
exports.urlSafe = urlSafe;
// adapted from source: http://stackoverflow.com/a/11058858
// this is used in place of TextEncode as the api is not yet
// well supported: https://caniuse.com/#search=TextEncoder
function textEncodeLite(str) {
    var buf = new ArrayBuffer(str.length);
    var bufView = new Uint8Array(buf);
    for (var i = 0; i < str.length; i++) {
        bufView[i] = str.charCodeAt(i);
    }
    return bufView;
}
exports.textEncodeLite = textEncodeLite;
/**
 * The default implementation of the `Crypto` interface.
 * This uses the capabilities of the browser.
 */
var DefaultCrypto = /** @class */ (function () {
    function DefaultCrypto() {
    }
    DefaultCrypto.prototype.generateRandom = function (size) {
        var buffer = new Uint8Array(size);
        if (HAS_CRYPTO) {
            window.crypto.getRandomValues(buffer);
        }
        else {
            // fall back to Math.random() if nothing else is available
            for (var i = 0; i < size; i += 1) {
                buffer[i] = (Math.random() * CHARSET.length) | 0;
            }
        }
        return bufferToString(buffer);
    };
    DefaultCrypto.prototype.deriveChallenge = function (code) {
        if (code.length < 43 || code.length > 128) {
            return Promise.reject(new errors.AppAuthError('Invalid code length.'));
        }
        if (!HAS_SUBTLE_CRYPTO) {
            return Promise.reject(new errors.AppAuthError('window.crypto.subtle is unavailable.'));
        }
        return new Promise(function (resolve, reject) {
            crypto.subtle.digest('SHA-256', textEncodeLite(code)).then(function (buffer) {
                return resolve(urlSafe(new Uint8Array(buffer)));
            }, function (error) { return reject(error); });
        });
    };
    return DefaultCrypto;
}());
exports.DefaultCrypto = DefaultCrypto;

});

var flags = createCommonjsModule(function (module, exports) {
/*
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License. You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under the
 * License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.IS_PROFILE = exports.IS_LOG = void 0;
/* Global flags that control the behavior of App Auth JS. */
/* Logging turned on ? */
exports.IS_LOG = true;
/* Profiling turned on ? */
exports.IS_PROFILE = false;

});

var logger = createCommonjsModule(function (module, exports) {
/*
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License. You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under the
 * License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __spreadArray = (commonjsGlobal && commonjsGlobal.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.profile = exports.log = void 0;

function log(message) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (flags.IS_LOG) {
        var length_1 = args ? args.length : 0;
        if (length_1 > 0) {
            console.log.apply(console, __spreadArray([message], args));
        }
        else {
            console.log(message);
        }
    }
}
exports.log = log;
// check to see if native support for profiling is available.
var NATIVE_PROFILE_SUPPORT = typeof window !== 'undefined' && !!window.performance && !!console.profile;
/**
 * A decorator that can profile a function.
 */
function profile(target, propertyKey, descriptor) {
    if (flags.IS_PROFILE) {
        return performProfile(target, propertyKey, descriptor);
    }
    else {
        // return as-is
        return descriptor;
    }
}
exports.profile = profile;
function performProfile(target, propertyKey, descriptor) {
    var originalCallable = descriptor.value;
    // name must exist
    var name = originalCallable.name;
    if (!name) {
        name = 'anonymous function';
    }
    if (NATIVE_PROFILE_SUPPORT) {
        descriptor.value = function (args) {
            console.profile(name);
            var startTime = window.performance.now();
            var result = originalCallable.call.apply(originalCallable, __spreadArray([this || window], args));
            var duration = window.performance.now() - startTime;
            console.log(name + " took " + duration + " ms");
            console.profileEnd();
            return result;
        };
    }
    else {
        descriptor.value = function (args) {
            log("Profile start " + name);
            var start = Date.now();
            var result = originalCallable.call.apply(originalCallable, __spreadArray([this || window], args));
            var duration = Date.now() - start;
            log("Profile end " + name + " took " + duration + " ms.");
            return result;
        };
    }
    return descriptor;
}

});

var authorization_request = createCommonjsModule(function (module, exports) {
/*
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License. You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under the
 * License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthorizationRequest = void 0;


/**
 * Generates a cryptographically random new state. Useful for CSRF protection.
 */
var SIZE = 10; // 10 bytes
var newState = function (crypto) {
    return crypto.generateRandom(SIZE);
};
/**
 * Represents the AuthorizationRequest.
 * For more information look at
 * https://tools.ietf.org/html/rfc6749#section-4.1.1
 */
var AuthorizationRequest = /** @class */ (function () {
    /**
     * Constructs a new AuthorizationRequest.
     * Use a `undefined` value for the `state` parameter, to generate a random
     * state for CSRF protection.
     */
    function AuthorizationRequest(request, crypto, usePkce) {
        if (crypto === void 0) { crypto = new crypto_utils.DefaultCrypto(); }
        if (usePkce === void 0) { usePkce = true; }
        this.crypto = crypto;
        this.usePkce = usePkce;
        this.clientId = request.client_id;
        this.redirectUri = request.redirect_uri;
        this.scope = request.scope;
        this.responseType = request.response_type || AuthorizationRequest.RESPONSE_TYPE_CODE;
        this.state = request.state || newState(crypto);
        this.extras = request.extras;
        // read internal properties if available
        this.internal = request.internal;
    }
    AuthorizationRequest.prototype.setupCodeVerifier = function () {
        var _this = this;
        if (!this.usePkce) {
            return Promise.resolve();
        }
        else {
            var codeVerifier_1 = this.crypto.generateRandom(128);
            var challenge = this.crypto.deriveChallenge(codeVerifier_1).catch(function (error) {
                logger.log('Unable to generate PKCE challenge. Not using PKCE', error);
                return undefined;
            });
            return challenge.then(function (result) {
                if (result) {
                    // keep track of the code used.
                    _this.internal = _this.internal || {};
                    _this.internal['code_verifier'] = codeVerifier_1;
                    _this.extras = _this.extras || {};
                    _this.extras['code_challenge'] = result;
                    // We always use S256. Plain is not good enough.
                    _this.extras['code_challenge_method'] = 'S256';
                }
            });
        }
    };
    /**
     * Serializes the AuthorizationRequest to a JavaScript Object.
     */
    AuthorizationRequest.prototype.toJson = function () {
        var _this = this;
        // Always make sure that the code verifier is setup when toJson() is called.
        return this.setupCodeVerifier().then(function () {
            return {
                response_type: _this.responseType,
                client_id: _this.clientId,
                redirect_uri: _this.redirectUri,
                scope: _this.scope,
                state: _this.state,
                extras: _this.extras,
                internal: _this.internal
            };
        });
    };
    AuthorizationRequest.RESPONSE_TYPE_TOKEN = 'token';
    AuthorizationRequest.RESPONSE_TYPE_CODE = 'code';
    return AuthorizationRequest;
}());
exports.AuthorizationRequest = AuthorizationRequest;

});

var authorization_request_handler = createCommonjsModule(function (module, exports) {
/*
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License. You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under the
 * License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthorizationRequestHandler = exports.BUILT_IN_PARAMETERS = exports.AuthorizationNotifier = void 0;

/**
 * Authorization Service notifier.
 * This manages the communication of the AuthorizationResponse to the 3p client.
 */
var AuthorizationNotifier = /** @class */ (function () {
    function AuthorizationNotifier() {
        this.listener = null;
    }
    AuthorizationNotifier.prototype.setAuthorizationListener = function (listener) {
        this.listener = listener;
    };
    /**
     * The authorization complete callback.
     */
    AuthorizationNotifier.prototype.onAuthorizationComplete = function (request, response, error) {
        if (this.listener) {
            // complete authorization request
            this.listener(request, response, error);
        }
    };
    return AuthorizationNotifier;
}());
exports.AuthorizationNotifier = AuthorizationNotifier;
// TODO(rahulrav@): add more built in parameters.
/* built in parameters. */
exports.BUILT_IN_PARAMETERS = ['redirect_uri', 'client_id', 'response_type', 'state', 'scope'];
/**
 * Defines the interface which is capable of handling an authorization request
 * using various methods (iframe / popup / different process etc.).
 */
var AuthorizationRequestHandler = /** @class */ (function () {
    function AuthorizationRequestHandler(utils, crypto) {
        this.utils = utils;
        this.crypto = crypto;
        // notifier send the response back to the client.
        this.notifier = null;
    }
    /**
     * A utility method to be able to build the authorization request URL.
     */
    AuthorizationRequestHandler.prototype.buildRequestUrl = function (configuration, request) {
        // build the query string
        // coerce to any type for convenience
        var requestMap = {
            'redirect_uri': request.redirectUri,
            'client_id': request.clientId,
            'response_type': request.responseType,
            'state': request.state,
            'scope': request.scope
        };
        // copy over extras
        if (request.extras) {
            for (var extra in request.extras) {
                if (request.extras.hasOwnProperty(extra)) {
                    // check before inserting to requestMap
                    if (exports.BUILT_IN_PARAMETERS.indexOf(extra) < 0) {
                        requestMap[extra] = request.extras[extra];
                    }
                }
            }
        }
        var query = this.utils.stringify(requestMap);
        var baseUrl = configuration.authorizationEndpoint;
        var url = baseUrl + "?" + query;
        return url;
    };
    /**
     * Completes the authorization request if necessary & when possible.
     */
    AuthorizationRequestHandler.prototype.completeAuthorizationRequestIfPossible = function () {
        var _this = this;
        // call complete authorization if possible to see there might
        // be a response that needs to be delivered.
        logger.log("Checking to see if there is an authorization response to be delivered.");
        if (!this.notifier) {
            logger.log("Notifier is not present on AuthorizationRequest handler.\n          No delivery of result will be possible");
        }
        return this.completeAuthorizationRequest().then(function (result) {
            if (!result) {
                logger.log("No result is available yet.");
            }
            if (result && _this.notifier) {
                _this.notifier.onAuthorizationComplete(result.request, result.response, result.error);
            }
        });
    };
    /**
     * Sets the default Authorization Service notifier.
     */
    AuthorizationRequestHandler.prototype.setAuthorizationNotifier = function (notifier) {
        this.notifier = notifier;
        return this;
    };
    return AuthorizationRequestHandler;
}());
exports.AuthorizationRequestHandler = AuthorizationRequestHandler;

});

var authorization_response = createCommonjsModule(function (module, exports) {
/*
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License. You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under the
 * License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthorizationError = exports.AuthorizationResponse = void 0;
/**
 * Represents the Authorization Response type.
 * For more information look at
 * https://tools.ietf.org/html/rfc6749#section-4.1.2
 */
var AuthorizationResponse = /** @class */ (function () {
    function AuthorizationResponse(response) {
        this.code = response.code;
        this.state = response.state;
    }
    AuthorizationResponse.prototype.toJson = function () {
        return { code: this.code, state: this.state };
    };
    return AuthorizationResponse;
}());
exports.AuthorizationResponse = AuthorizationResponse;
/**
 * Represents the Authorization error response.
 * For more information look at:
 * https://tools.ietf.org/html/rfc6749#section-4.1.2.1
 */
var AuthorizationError = /** @class */ (function () {
    function AuthorizationError(error) {
        this.error = error.error;
        this.errorDescription = error.error_description;
        this.errorUri = error.error_uri;
        this.state = error.state;
    }
    AuthorizationError.prototype.toJson = function () {
        return {
            error: this.error,
            error_description: this.errorDescription,
            error_uri: this.errorUri,
            state: this.state
        };
    };
    return AuthorizationError;
}());
exports.AuthorizationError = AuthorizationError;

});

var xhr = createCommonjsModule(function (module, exports) {
/*
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License. You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under the
 * License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __extends = (commonjsGlobal && commonjsGlobal.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TestRequestor = exports.FetchRequestor = exports.JQueryRequestor = exports.Requestor = void 0;

/**
 * An class that abstracts away the ability to make an XMLHttpRequest.
 */
var Requestor = /** @class */ (function () {
    function Requestor() {
    }
    return Requestor;
}());
exports.Requestor = Requestor;
/**
 * Uses $.ajax to makes the Ajax requests.
 */
var JQueryRequestor = /** @class */ (function (_super) {
    __extends(JQueryRequestor, _super);
    function JQueryRequestor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    JQueryRequestor.prototype.xhr = function (settings) {
        // NOTE: using jquery to make XHR's as whatwg-fetch requires
        // that I target ES6.
        var xhr = $.ajax(settings);
        return new Promise(function (resolve, reject) {
            xhr.then(function (data, textStatus, jqXhr) {
                resolve(data);
            }, function (jqXhr, textStatus, error) {
                reject(new errors.AppAuthError(error));
            });
        });
    };
    return JQueryRequestor;
}(Requestor));
exports.JQueryRequestor = JQueryRequestor;
/**
 * Uses fetch API to make Ajax requests
 */
var FetchRequestor = /** @class */ (function (_super) {
    __extends(FetchRequestor, _super);
    function FetchRequestor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FetchRequestor.prototype.xhr = function (settings) {
        if (!settings.url) {
            return Promise.reject(new errors.AppAuthError('A URL must be provided.'));
        }
        var url = new URL(settings.url);
        var requestInit = {};
        requestInit.method = settings.method;
        requestInit.mode = 'cors';
        if (settings.data) {
            if (settings.method && settings.method.toUpperCase() === 'POST') {
                requestInit.body = settings.data;
            }
            else {
                var searchParams = new URLSearchParams(settings.data);
                searchParams.forEach(function (value, key) {
                    url.searchParams.append(key, value);
                });
            }
        }
        // Set the request headers
        requestInit.headers = {};
        if (settings.headers) {
            for (var i in settings.headers) {
                if (settings.headers.hasOwnProperty(i)) {
                    requestInit.headers[i] = settings.headers[i];
                }
            }
        }
        var isJsonDataType = settings.dataType && settings.dataType.toLowerCase() === 'json';
        // Set 'Accept' header value for json requests (Taken from
        // https://github.com/jquery/jquery/blob/e0d941156900a6bff7c098c8ea7290528e468cf8/src/ajax.js#L644
        // )
        if (isJsonDataType) {
            requestInit.headers['Accept'] = 'application/json, text/javascript, */*; q=0.01';
        }
        return fetch(url.toString(), requestInit).then(function (response) {
            if (response.status >= 200 && response.status < 300) {
                var contentType = response.headers.get('content-type');
                if (isJsonDataType || (contentType && contentType.indexOf('application/json') !== -1)) {
                    return response.json();
                }
                else {
                    return response.text();
                }
            }
            else {
                return Promise.reject(new errors.AppAuthError(response.status.toString(), response.statusText));
            }
        });
    };
    return FetchRequestor;
}(Requestor));
exports.FetchRequestor = FetchRequestor;
/**
 * Should be used only in the context of testing. Just uses the underlying
 * Promise to mock the behavior of the Requestor.
 */
var TestRequestor = /** @class */ (function (_super) {
    __extends(TestRequestor, _super);
    function TestRequestor(promise) {
        var _this = _super.call(this) || this;
        _this.promise = promise;
        return _this;
    }
    TestRequestor.prototype.xhr = function (settings) {
        return this.promise; // unsafe cast
    };
    return TestRequestor;
}(Requestor));
exports.TestRequestor = TestRequestor;

});

var authorization_service_configuration = createCommonjsModule(function (module, exports) {
/*
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License. You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under the
 * License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthorizationServiceConfiguration = void 0;

/**
 * The standard base path for well-known resources on domains.
 * See https://tools.ietf.org/html/rfc5785 for more information.
 */
var WELL_KNOWN_PATH = '.well-known';
/**
 * The standard resource under the well known path at which an OpenID Connect
 * discovery document can be found under an issuer's base URI.
 */
var OPENID_CONFIGURATION = 'openid-configuration';
/**
 * Configuration details required to interact with an authorization service.
 *
 * More information at https://openid.net/specs/openid-connect-discovery-1_0-17.html
 */
var AuthorizationServiceConfiguration = /** @class */ (function () {
    function AuthorizationServiceConfiguration(request) {
        this.authorizationEndpoint = request.authorization_endpoint;
        this.tokenEndpoint = request.token_endpoint;
        this.revocationEndpoint = request.revocation_endpoint;
        this.userInfoEndpoint = request.userinfo_endpoint;
        this.endSessionEndpoint = request.end_session_endpoint;
    }
    AuthorizationServiceConfiguration.prototype.toJson = function () {
        return {
            authorization_endpoint: this.authorizationEndpoint,
            token_endpoint: this.tokenEndpoint,
            revocation_endpoint: this.revocationEndpoint,
            end_session_endpoint: this.endSessionEndpoint,
            userinfo_endpoint: this.userInfoEndpoint
        };
    };
    AuthorizationServiceConfiguration.fetchFromIssuer = function (openIdIssuerUrl, requestor) {
        var fullUrl = openIdIssuerUrl + "/" + WELL_KNOWN_PATH + "/" + OPENID_CONFIGURATION;
        var requestorToUse = requestor || new xhr.JQueryRequestor();
        return requestorToUse
            .xhr({ url: fullUrl, dataType: 'json', method: 'GET' })
            .then(function (json) { return new AuthorizationServiceConfiguration(json); });
    };
    return AuthorizationServiceConfiguration;
}());
exports.AuthorizationServiceConfiguration = AuthorizationServiceConfiguration;

});

var query_string_utils = createCommonjsModule(function (module, exports) {
/*
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License. You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under the
 * License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BasicQueryStringUtils = void 0;
var BasicQueryStringUtils = /** @class */ (function () {
    function BasicQueryStringUtils() {
    }
    BasicQueryStringUtils.prototype.parse = function (input, useHash) {
        if (useHash) {
            return this.parseQueryString(input.hash);
        }
        else {
            return this.parseQueryString(input.search);
        }
    };
    BasicQueryStringUtils.prototype.parseQueryString = function (query) {
        var result = {};
        // if anything starts with ?, # or & remove it
        query = query.trim().replace(/^(\?|#|&)/, '');
        var params = query.split('&');
        for (var i = 0; i < params.length; i += 1) {
            var param = params[i]; // looks something like a=b
            var parts = param.split('=');
            if (parts.length >= 2) {
                var key = decodeURIComponent(parts.shift());
                var value = parts.length > 0 ? parts.join('=') : null;
                if (value) {
                    result[key] = decodeURIComponent(value);
                }
            }
        }
        return result;
    };
    BasicQueryStringUtils.prototype.stringify = function (input) {
        var encoded = [];
        for (var key in input) {
            if (input.hasOwnProperty(key) && input[key]) {
                encoded.push(encodeURIComponent(key) + "=" + encodeURIComponent(input[key]));
            }
        }
        return encoded.join('&');
    };
    return BasicQueryStringUtils;
}());
exports.BasicQueryStringUtils = BasicQueryStringUtils;

});

var storage = createCommonjsModule(function (module, exports) {
/*
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License. You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under the
 * License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __extends = (commonjsGlobal && commonjsGlobal.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalStorageBackend = exports.StorageBackend = void 0;
/**
 * Asynchronous storage APIs. All methods return a `Promise`.
 * All methods take the `DOMString`
 * IDL type (as it is the lowest common denominator).
 */
var StorageBackend = /** @class */ (function () {
    function StorageBackend() {
    }
    return StorageBackend;
}());
exports.StorageBackend = StorageBackend;
/**
 * A `StorageBackend` backed by `localstorage`.
 */
var LocalStorageBackend = /** @class */ (function (_super) {
    __extends(LocalStorageBackend, _super);
    function LocalStorageBackend(storage) {
        var _this = _super.call(this) || this;
        _this.storage = storage || window.localStorage;
        return _this;
    }
    LocalStorageBackend.prototype.getItem = function (name) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var value = _this.storage.getItem(name);
            if (value) {
                resolve(value);
            }
            else {
                resolve(null);
            }
        });
    };
    LocalStorageBackend.prototype.removeItem = function (name) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.storage.removeItem(name);
            resolve();
        });
    };
    LocalStorageBackend.prototype.clear = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.storage.clear();
            resolve();
        });
    };
    LocalStorageBackend.prototype.setItem = function (name, value) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.storage.setItem(name, value);
            resolve();
        });
    };
    return LocalStorageBackend;
}(StorageBackend));
exports.LocalStorageBackend = LocalStorageBackend;

});

var redirect_based_handler = createCommonjsModule(function (module, exports) {
/*
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License. You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under the
 * License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __extends = (commonjsGlobal && commonjsGlobal.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.RedirectRequestHandler = void 0;







/** key for authorization request. */
var authorizationRequestKey = function (handle) {
    return handle + "_appauth_authorization_request";
};
/** key for authorization service configuration */
var authorizationServiceConfigurationKey = function (handle) {
    return handle + "_appauth_authorization_service_configuration";
};
/** key in local storage which represents the current authorization request. */
var AUTHORIZATION_REQUEST_HANDLE_KEY = 'appauth_current_authorization_request';
/**
 * Represents an AuthorizationRequestHandler which uses a standard
 * redirect based code flow.
 */
var RedirectRequestHandler = /** @class */ (function (_super) {
    __extends(RedirectRequestHandler, _super);
    function RedirectRequestHandler(
    // use the provided storage backend
    // or initialize local storage with the default storage backend which
    // uses window.localStorage
    storageBackend, utils, locationLike, crypto) {
        if (storageBackend === void 0) { storageBackend = new storage.LocalStorageBackend(); }
        if (utils === void 0) { utils = new query_string_utils.BasicQueryStringUtils(); }
        if (locationLike === void 0) { locationLike = window.location; }
        if (crypto === void 0) { crypto = new crypto_utils.DefaultCrypto(); }
        var _this = _super.call(this, utils, crypto) || this;
        _this.storageBackend = storageBackend;
        _this.locationLike = locationLike;
        return _this;
    }
    RedirectRequestHandler.prototype.performAuthorizationRequest = function (configuration, request) {
        var _this = this;
        var handle = this.crypto.generateRandom(10);
        // before you make request, persist all request related data in local storage.
        var persisted = Promise.all([
            this.storageBackend.setItem(AUTHORIZATION_REQUEST_HANDLE_KEY, handle),
            // Calling toJson() adds in the code & challenge when possible
            request.toJson().then(function (result) {
                return _this.storageBackend.setItem(authorizationRequestKey(handle), JSON.stringify(result));
            }),
            this.storageBackend.setItem(authorizationServiceConfigurationKey(handle), JSON.stringify(configuration.toJson())),
        ]);
        persisted.then(function () {
            // make the redirect request
            var url = _this.buildRequestUrl(configuration, request);
            logger.log('Making a request to ', request, url);
            _this.locationLike.assign(url);
        });
    };
    /**
     * Attempts to introspect the contents of storage backend and completes the
     * request.
     */
    RedirectRequestHandler.prototype.completeAuthorizationRequest = function () {
        var _this = this;
        // TODO(rahulrav@): handle authorization errors.
        return this.storageBackend.getItem(AUTHORIZATION_REQUEST_HANDLE_KEY).then(function (handle) {
            if (handle) {
                // we have a pending request.
                // fetch authorization request, and check state
                return _this.storageBackend
                    .getItem(authorizationRequestKey(handle))
                    // requires a corresponding instance of result
                    // TODO(rahulrav@): check for inconsitent state here
                    .then(function (result) { return JSON.parse(result); })
                    .then(function (json) { return new authorization_request.AuthorizationRequest(json); })
                    .then(function (request) {
                    // check redirect_uri and state
                    var currentUri = "" + _this.locationLike.origin + _this.locationLike.pathname;
                    var queryParams = _this.utils.parse(_this.locationLike, true /* use hash */);
                    var state = queryParams['state'];
                    var code = queryParams['code'];
                    var error = queryParams['error'];
                    logger.log('Potential authorization request ', currentUri, queryParams, state, code, error);
                    var shouldNotify = state === request.state;
                    var authorizationResponse = null;
                    var authorizationError = null;
                    if (shouldNotify) {
                        if (error) {
                            // get additional optional info.
                            var errorUri = queryParams['error_uri'];
                            var errorDescription = queryParams['error_description'];
                            authorizationError = new authorization_response.AuthorizationError({
                                error: error,
                                error_description: errorDescription,
                                error_uri: errorUri,
                                state: state
                            });
                        }
                        else {
                            authorizationResponse = new authorization_response.AuthorizationResponse({ code: code, state: state });
                        }
                        // cleanup state
                        return Promise
                            .all([
                            _this.storageBackend.removeItem(AUTHORIZATION_REQUEST_HANDLE_KEY),
                            _this.storageBackend.removeItem(authorizationRequestKey(handle)),
                            _this.storageBackend.removeItem(authorizationServiceConfigurationKey(handle))
                        ])
                            .then(function () {
                            logger.log('Delivering authorization response');
                            return {
                                request: request,
                                response: authorizationResponse,
                                error: authorizationError
                            };
                        });
                    }
                    else {
                        logger.log('Mismatched request (state and request_uri) dont match.');
                        return Promise.resolve(null);
                    }
                });
            }
            else {
                return null;
            }
        });
    };
    return RedirectRequestHandler;
}(authorization_request_handler.AuthorizationRequestHandler));
exports.RedirectRequestHandler = RedirectRequestHandler;

});

var revoke_token_request = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.RevokeTokenRequest = void 0;
/**
 * Represents a revoke token request.
 * For more information look at:
 * https://tools.ietf.org/html/rfc7009#section-2.1
 */
var RevokeTokenRequest = /** @class */ (function () {
    function RevokeTokenRequest(request) {
        this.token = request.token;
        this.tokenTypeHint = request.token_type_hint;
        this.clientId = request.client_id;
        this.clientSecret = request.client_secret;
    }
    /**
     * Serializes a TokenRequest to a JavaScript object.
     */
    RevokeTokenRequest.prototype.toJson = function () {
        var json = { token: this.token };
        if (this.tokenTypeHint) {
            json['token_type_hint'] = this.tokenTypeHint;
        }
        if (this.clientId) {
            json['client_id'] = this.clientId;
        }
        if (this.clientSecret) {
            json['client_secret'] = this.clientSecret;
        }
        return json;
    };
    RevokeTokenRequest.prototype.toStringMap = function () {
        var json = this.toJson();
        // :(
        return json;
    };
    return RevokeTokenRequest;
}());
exports.RevokeTokenRequest = RevokeTokenRequest;

});

var token_request = createCommonjsModule(function (module, exports) {
/*
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License. You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under the
 * License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenRequest = exports.GRANT_TYPE_REFRESH_TOKEN = exports.GRANT_TYPE_AUTHORIZATION_CODE = void 0;
exports.GRANT_TYPE_AUTHORIZATION_CODE = 'authorization_code';
exports.GRANT_TYPE_REFRESH_TOKEN = 'refresh_token';
/**
 * Represents an Access Token request.
 * For more information look at:
 * https://tools.ietf.org/html/rfc6749#section-4.1.3
 */
var TokenRequest = /** @class */ (function () {
    function TokenRequest(request) {
        this.clientId = request.client_id;
        this.redirectUri = request.redirect_uri;
        this.grantType = request.grant_type;
        this.code = request.code;
        this.refreshToken = request.refresh_token;
        this.extras = request.extras;
    }
    /**
     * Serializes a TokenRequest to a JavaScript object.
     */
    TokenRequest.prototype.toJson = function () {
        return {
            grant_type: this.grantType,
            code: this.code,
            refresh_token: this.refreshToken,
            redirect_uri: this.redirectUri,
            client_id: this.clientId,
            extras: this.extras
        };
    };
    TokenRequest.prototype.toStringMap = function () {
        var map = {
            grant_type: this.grantType,
            client_id: this.clientId,
            redirect_uri: this.redirectUri
        };
        if (this.code) {
            map['code'] = this.code;
        }
        if (this.refreshToken) {
            map['refresh_token'] = this.refreshToken;
        }
        // copy over extras
        if (this.extras) {
            for (var extra in this.extras) {
                if (this.extras.hasOwnProperty(extra) && !map.hasOwnProperty(extra)) {
                    // check before inserting to requestMap
                    map[extra] = this.extras[extra];
                }
            }
        }
        return map;
    };
    return TokenRequest;
}());
exports.TokenRequest = TokenRequest;

});

var token_response = createCommonjsModule(function (module, exports) {
/*
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License. You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under the
 * License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenError = exports.TokenResponse = exports.nowInSeconds = void 0;
// constants
var AUTH_EXPIRY_BUFFER = 10 * 60 * -1; // 10 mins in seconds
/**
 * Returns the instant of time in seconds.
 */
var nowInSeconds = function () { return Math.round(new Date().getTime() / 1000); };
exports.nowInSeconds = nowInSeconds;
/**
 * Represents the Token Response type.
 * For more information look at:
 * https://tools.ietf.org/html/rfc6749#section-5.1
 */
var TokenResponse = /** @class */ (function () {
    function TokenResponse(response) {
        this.accessToken = response.access_token;
        this.tokenType = response.token_type || 'bearer';
        if (response.expires_in) {
            this.expiresIn = parseInt(response.expires_in, 10);
        }
        this.refreshToken = response.refresh_token;
        this.scope = response.scope;
        this.idToken = response.id_token;
        this.issuedAt = response.issued_at || exports.nowInSeconds();
    }
    TokenResponse.prototype.toJson = function () {
        var _a;
        return {
            access_token: this.accessToken,
            id_token: this.idToken,
            refresh_token: this.refreshToken,
            scope: this.scope,
            token_type: this.tokenType,
            issued_at: this.issuedAt,
            expires_in: (_a = this.expiresIn) === null || _a === void 0 ? void 0 : _a.toString()
        };
    };
    TokenResponse.prototype.isValid = function (buffer) {
        if (buffer === void 0) { buffer = AUTH_EXPIRY_BUFFER; }
        if (this.expiresIn) {
            var now = exports.nowInSeconds();
            return now < this.issuedAt + this.expiresIn + buffer;
        }
        else {
            return true;
        }
    };
    return TokenResponse;
}());
exports.TokenResponse = TokenResponse;
/**
 * Represents the Token Error type.
 * For more information look at:
 * https://tools.ietf.org/html/rfc6749#section-5.2
 */
var TokenError = /** @class */ (function () {
    function TokenError(tokenError) {
        this.error = tokenError.error;
        this.errorDescription = tokenError.error_description;
        this.errorUri = tokenError.error_uri;
    }
    TokenError.prototype.toJson = function () {
        return {
            error: this.error, error_description: this.errorDescription, error_uri: this.errorUri
        };
    };
    return TokenError;
}());
exports.TokenError = TokenError;

});

var token_request_handler = createCommonjsModule(function (module, exports) {
/*
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License. You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under the
 * License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseTokenRequestHandler = void 0;




/**
 * The default token request handler.
 */
var BaseTokenRequestHandler = /** @class */ (function () {
    function BaseTokenRequestHandler(requestor, utils) {
        if (requestor === void 0) { requestor = new xhr.JQueryRequestor(); }
        if (utils === void 0) { utils = new query_string_utils.BasicQueryStringUtils(); }
        this.requestor = requestor;
        this.utils = utils;
    }
    BaseTokenRequestHandler.prototype.isTokenResponse = function (response) {
        return response.error === undefined;
    };
    BaseTokenRequestHandler.prototype.performRevokeTokenRequest = function (configuration, request) {
        var revokeTokenResponse = this.requestor.xhr({
            url: configuration.revocationEndpoint,
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data: this.utils.stringify(request.toStringMap())
        });
        return revokeTokenResponse.then(function (response) {
            return true;
        });
    };
    BaseTokenRequestHandler.prototype.performTokenRequest = function (configuration, request) {
        var _this = this;
        var tokenResponse = this.requestor.xhr({
            url: configuration.tokenEndpoint,
            method: 'POST',
            dataType: 'json',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data: this.utils.stringify(request.toStringMap())
        });
        return tokenResponse.then(function (response) {
            if (_this.isTokenResponse(response)) {
                return new token_response.TokenResponse(response);
            }
            else {
                return Promise.reject(new errors.AppAuthError(response.error, new token_response.TokenError(response)));
            }
        });
    };
    return BaseTokenRequestHandler;
}());
exports.BaseTokenRequestHandler = BaseTokenRequestHandler;

});

var types = createCommonjsModule(function (module, exports) {
/*
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License. You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under the
 * License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });

});

var built = createCommonjsModule(function (module, exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(authorization_request, exports);
__exportStar(authorization_request_handler, exports);
__exportStar(authorization_response, exports);
__exportStar(authorization_service_configuration, exports);
__exportStar(crypto_utils, exports);
__exportStar(errors, exports);
__exportStar(flags, exports);
__exportStar(logger, exports);
__exportStar(query_string_utils, exports);
__exportStar(redirect_based_handler, exports);
__exportStar(revoke_token_request, exports);
__exportStar(storage, exports);
__exportStar(token_request, exports);
__exportStar(token_request_handler, exports);
__exportStar(token_response, exports);
__exportStar(types, exports);
__exportStar(xhr, exports);

});

var checkSessionIFrame = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckSessionIFrame = void 0;
const DefaultInterval = 2000;
const Log = console;
class CheckSessionIFrame {
    constructor(callback, client_id, url, interval = DefaultInterval, stopOnError = true) {
        this._callback = callback;
        this._client_id = client_id;
        this._url = url;
        this._interval = interval || DefaultInterval;
        this._stopOnError = stopOnError;
        const idx = url.indexOf('/', url.indexOf('//') + 2);
        this._frame_origin = url.substr(0, idx);
        this._frame = window.document.createElement('iframe');
        this._frame.style.visibility = 'hidden';
        this._frame.style.position = 'absolute';
        this._frame.style.display = 'none';
        // @ts-ignore
        this._frame.width = 0;
        // @ts-ignore
        this._frame.height = 0;
        this._frame.src = url;
    }
    load() {
        return new Promise((resolve) => {
            this._frame.onload = () => {
                resolve();
            };
            window.document.body.appendChild(this._frame);
            this._boundMessageEvent = this._message.bind(this);
            window.addEventListener('message', this._boundMessageEvent, false);
        });
    }
    _message(e) {
        if (e.origin === this._frame_origin &&
            e.source === this._frame.contentWindow) {
            if (e.data === 'error') {
                Log.error('CheckSessionIFrame: error message from check session op iframe');
                if (this._stopOnError) {
                    this.stop();
                }
            }
            else if (e.data === 'changed') {
                Log.debug(e);
                Log.debug('CheckSessionIFrame: changed message from check session op iframe');
                this.stop();
                this._callback();
            }
            else {
                Log.debug('CheckSessionIFrame: ' + e.data + ' message from check session op iframe');
            }
        }
    }
    start(session_state) {
        Log.debug('CheckSessionIFrame.start :' + session_state);
        this.stop();
        const send = () => {
            this._frame.contentWindow.postMessage(this._client_id + ' ' + session_state, this._frame_origin);
        };
        send();
        this._timer = window.setInterval(send, this._interval);
    }
    stop() {
        if (this._timer) {
            Log.debug('CheckSessionIFrame.stop');
            window.clearInterval(this._timer);
            this._timer = null;
        }
    }
}
exports.CheckSessionIFrame = CheckSessionIFrame;

});

var initSession_1 = createCommonjsModule(function (module, exports) {
var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initSession = void 0;
const initSession = (configurationName, redirectUri, storage = sessionStorage) => {
    const saveItemsAsync = (items) => {
        storage[`oidc_items.${configurationName}:${redirectUri}`] = JSON.stringify(items);
        return Promise.resolve();
    };
    const loadItemsAsync = () => {
        return Promise.resolve(JSON.parse(storage[`oidc_items.${configurationName}:${redirectUri}`]));
    };
    const clearAsync = (status) => {
        storage[`oidc.${configurationName}:${redirectUri}`] = JSON.stringify({ tokens: null, status });
        return Promise.resolve();
    };
    const initAsync = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!storage[`oidc.${configurationName}:${redirectUri}`]) {
            storage[`oidc.${configurationName}:${redirectUri}`] = JSON.stringify({ tokens: null, status: null });
            return { tokens: null, status: null };
        }
        const data = JSON.parse(storage[`oidc.${configurationName}:${redirectUri}`]);
        return Promise.resolve({ tokens: data.tokens, status: data.status });
    });
    const setTokens = (tokens) => {
        storage[`oidc.${configurationName}:${redirectUri}`] = JSON.stringify({ tokens });
    };
    const setSessionState = (sessionState) => {
        storage[`oidc.session_state.${configurationName}:${redirectUri}`] = sessionState;
    };
    const getSessionState = () => {
        return storage[`oidc.session_state.${configurationName}:${redirectUri}`];
    };
    const setNonceAsync = (nonce) => {
        localStorage[`oidc.nonce.${configurationName}:${redirectUri}`] = nonce.nonce;
    };
    const getNonceAsync = () => __awaiter(void 0, void 0, void 0, function* () {
        // @ts-ignore
        return { nonce: localStorage[`oidc.nonce.${configurationName}:${redirectUri}`] };
    });
    const getTokens = () => {
        if (!storage[`oidc.${configurationName}:${redirectUri}`]) {
            return null;
        }
        return JSON.stringify({ tokens: JSON.parse(storage[`oidc.${configurationName}:${redirectUri}`]).tokens });
    };
    return {
        saveItemsAsync,
        loadItemsAsync,
        clearAsync,
        initAsync,
        setTokens,
        getTokens,
        setSessionState,
        getSessionState,
        setNonceAsync,
        getNonceAsync,
    };
};
exports.initSession = initSession;

});

var parseTokens = createCommonjsModule(function (module, exports) {
var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTokensOidcValid = exports.getValidTokenAsync = exports.isTokensValid = exports.computeTimeLeft = exports.parseOriginalTokens = exports.setTokens = exports.TokenRenewMode = void 0;

const b64DecodeUnicode = (str) => decodeURIComponent(Array.prototype.map.call(atob(str), (c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join(''));
const parseJwt = (token) => JSON.parse(b64DecodeUnicode(token.split('.')[1].replace('-', '+').replace('_', '/')));
const extractTokenPayload = (token) => {
    try {
        if (!token) {
            return null;
        }
        if (countLetter(token, '.') === 2) {
            return parseJwt(token);
        }
        else {
            return null;
        }
    }
    catch (e) {
        console.warn(e);
    }
    return null;
};
const countLetter = (str, find) => {
    return (str.split(find)).length - 1;
};
exports.TokenRenewMode = {
    access_token_or_id_token_invalid: 'access_token_or_id_token_invalid',
    access_token_invalid: 'access_token_invalid',
    id_token_invalid: 'id_token_invalid',
};
const setTokens = (tokens, oldTokens = null, tokenRenewMode) => {
    if (!tokens) {
        return null;
    }
    let accessTokenPayload;
    if (!tokens.issuedAt) {
        const currentTimeUnixSecond = new Date().getTime() / 1000;
        tokens.issuedAt = currentTimeUnixSecond;
    }
    if (tokens.accessTokenPayload !== undefined) {
        accessTokenPayload = tokens.accessTokenPayload;
    }
    else {
        accessTokenPayload = extractTokenPayload(tokens.accessToken);
    }
    const _idTokenPayload = tokens.idTokenPayload ? tokens.idTokenPayload : extractTokenPayload(tokens.idToken);
    const idTokenExpireAt = (_idTokenPayload && _idTokenPayload.exp) ? _idTokenPayload.exp : Number.MAX_VALUE;
    const accessTokenExpiresAt = (accessTokenPayload && accessTokenPayload.exp) ? accessTokenPayload.exp : tokens.issuedAt + tokens.expiresIn;
    let expiresAt;
    if (tokenRenewMode === exports.TokenRenewMode.access_token_invalid) {
        expiresAt = accessTokenExpiresAt;
    }
    else if (tokenRenewMode === exports.TokenRenewMode.id_token_invalid) {
        expiresAt = idTokenExpireAt;
    }
    else {
        expiresAt = idTokenExpireAt < accessTokenExpiresAt ? idTokenExpireAt : accessTokenExpiresAt;
    }
    const newTokens = Object.assign(Object.assign({}, tokens), { idTokenPayload: _idTokenPayload, accessTokenPayload, expiresAt });
    // When refresh_token is not rotated we reuse ald refresh_token
    if (oldTokens != null && 'refreshToken' in oldTokens && !('refreshToken' in tokens)) {
        const refreshToken = oldTokens.refreshToken;
        return Object.assign(Object.assign({}, newTokens), { refreshToken });
    }
    return newTokens;
};
exports.setTokens = setTokens;
const parseOriginalTokens = (tokens, oldTokens, tokenRenewMode) => {
    if (!tokens) {
        return null;
    }
    if (!tokens.issued_at) {
        const currentTimeUnixSecond = new Date().getTime() / 1000;
        tokens.issued_at = currentTimeUnixSecond;
    }
    const data = {
        accessToken: tokens.access_token,
        expiresIn: tokens.expires_in,
        idToken: tokens.id_token,
        scope: tokens.scope,
        tokenType: tokens.token_type,
        issuedAt: tokens.issued_at,
    };
    if ('refresh_token' in tokens) {
        // @ts-ignore
        data.refreshToken = tokens.refresh_token;
    }
    if (tokens.accessTokenPayload !== undefined) {
        // @ts-ignore
        data.accessTokenPayload = tokens.accessTokenPayload;
    }
    if (tokens.idTokenPayload !== undefined) {
        // @ts-ignore
        data.idTokenPayload = tokens.idTokenPayload;
    }
    return (0, exports.setTokens)(data, oldTokens, tokenRenewMode);
};
exports.parseOriginalTokens = parseOriginalTokens;
const computeTimeLeft = (refreshTimeBeforeTokensExpirationInSecond, expiresAt) => {
    const currentTimeUnixSecond = new Date().getTime() / 1000;
    return Math.round(((expiresAt - refreshTimeBeforeTokensExpirationInSecond) - currentTimeUnixSecond));
};
exports.computeTimeLeft = computeTimeLeft;
const isTokensValid = (tokens) => {
    if (!tokens) {
        return false;
    }
    return (0, exports.computeTimeLeft)(0, tokens.expiresAt) > 0;
};
exports.isTokensValid = isTokensValid;
const getValidTokenAsync = (oidc, waitMs = 200, numberWait = 50) => __awaiter(void 0, void 0, void 0, function* () {
    let numberWaitTemp = numberWait;
    while (!(0, exports.isTokensValid)(oidc.tokens) && numberWaitTemp > 0) {
        yield (0, initWorker.sleepAsync)(waitMs);
        numberWaitTemp = numberWaitTemp - 1;
    }
    const isValid = (0, exports.isTokensValid)(oidc.tokens);
    return {
        isTokensValid: isValid,
        tokens: oidc.tokens,
        numberWaited: numberWaitTemp - numberWait,
    };
});
exports.getValidTokenAsync = getValidTokenAsync;
// https://openid.net/specs/openid-connect-core-1_0.html#IDTokenValidation (excluding rules #1, #4, #5, #7, #8, #12, and #13 which did not apply).
// https://github.com/openid/AppAuth-JS/issues/65
const isTokensOidcValid = (tokens, nonce, oidcServerConfiguration) => {
    if (tokens.idTokenPayload) {
        const idTokenPayload = tokens.idTokenPayload;
        // 2: The Issuer Identifier for the OpenID Provider (which is typically obtained during Discovery) MUST exactly match the value of the iss (issuer) Claim.
        if (oidcServerConfiguration.issuer !== idTokenPayload.iss) {
            return false;
        }
        // 3: The Client MUST validate that the aud (audience) Claim contains its client_id value registered at the Issuer identified by the iss (issuer) Claim as an audience. The aud (audience) Claim MAY contain an array with more than one element. The ID Token MUST be rejected if the ID Token does not list the Client as a valid audience, or if it contains additional audiences not trusted by the Client.
        // 6: If the ID Token is received via direct communication between the Client and the Token Endpoint (which it is in this flow), the TLS server validation MAY be used to validate the issuer in place of checking the token signature. The Client MUST validate the signature of all other ID Tokens according to JWS [JWS] using the algorithm specified in the JWT alg Header Parameter. The Client MUST use the keys provided by the Issuer.
        // 9: The current time MUST be before the time represented by the exp Claim.
        const currentTimeUnixSecond = new Date().getTime() / 1000;
        if (idTokenPayload.exp && idTokenPayload.exp < currentTimeUnixSecond) {
            return false;
        }
        // 10: The iat Claim can be used to reject tokens that were issued too far away from the current time, limiting the amount of time that nonces need to be stored to prevent attacks. The acceptable range is Client specific.
        const timeInSevenDays = 60 * 60 * 24 * 7;
        if (idTokenPayload.iat && (idTokenPayload.iat + timeInSevenDays) < currentTimeUnixSecond) {
            return false;
        }
        // 11: If a nonce value was sent in the Authentication Request, a nonce Claim MUST be present and its value checked to verify that it is the same value as the one that was sent in the Authentication Request. The Client SHOULD check the nonce value for replay attacks. The precise method for detecting replay attacks is Client specific.
        if (idTokenPayload.nonce && idTokenPayload.nonce !== nonce) {
            return false;
        }
    }
    return true;
};
exports.isTokensOidcValid = isTokensOidcValid;

});

var timer_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
const timer = (function () {
    const workerPort = (function () {
        let worker;
        let blobURL;
        const workerCode = function () {
            const innerIdsByOuterIds = {};
            const methods = {
                setTimeout: function (port, id, timeout) {
                    innerIdsByOuterIds[id] = setTimeout(function () {
                        port.postMessage(id);
                        innerIdsByOuterIds[id] = null;
                    }, timeout);
                },
                setInterval: function (port, id, timeout) {
                    innerIdsByOuterIds[id] = setInterval(function () {
                        port.postMessage(id);
                    }, timeout);
                },
                clearTimeout: function (port, id) {
                    clearTimeout(innerIdsByOuterIds[id]);
                    innerIdsByOuterIds[id] = null;
                },
                clearInterval: function (port, id) {
                    clearInterval(innerIdsByOuterIds[id]);
                    innerIdsByOuterIds[id] = null;
                },
            };
            function onMessage(port, event) {
                const method = event.data[0];
                const id = event.data[1];
                const option = event.data[2];
                if (methods[method]) {
                    methods[method](port, id, option);
                }
            }
            // For Dedicated Worker
            this.onmessage = function (event) {
                onMessage(self, event);
            };
            // For Shared Worker
            this.onconnect = function (event) {
                const port = event.ports[0];
                port.onmessage = function (event) {
                    onMessage(port, event);
                };
            };
        }.toString();
        try {
            const blob = new Blob(['(', workerCode, ')()'], { type: 'application/javascript' });
            blobURL = URL.createObjectURL(blob);
        }
        catch (error) {
            return null;
        }
        const isInsideBrowser = (typeof process === 'undefined');
        try {
            if (SharedWorker) {
                worker = new SharedWorker(blobURL);
                return worker.port;
            }
        }
        catch (error) {
            if (isInsideBrowser) {
                console.warn('SharedWorker not available');
            }
        }
        try {
            if (Worker) {
                worker = new Worker(blobURL);
                return worker;
            }
        }
        catch (error) {
            if (isInsideBrowser) {
                console.warn('Worker not available');
            }
        }
        return null;
    }());
    if (!workerPort) {
        // In NextJS with SSR (Server Side Rendering) during rending in Node JS, the window object is undefined,
        // the global object is used instead as it is the closest approximation of a browsers window object.
        const bindContext = (typeof window === 'undefined') ? commonjsGlobal : window;
        return {
            setTimeout: setTimeout.bind(bindContext),
            clearTimeout: clearTimeout.bind(bindContext),
            setInterval: setInterval.bind(bindContext),
            clearInterval: clearInterval.bind(bindContext),
        };
    }
    const getId = (function () {
        let currentId = 0;
        return function () {
            currentId++;
            return currentId;
        };
    }());
    const timeoutCallbacksById = {};
    const intervalCallbacksById = {};
    workerPort.onmessage = function (event) {
        const id = event.data;
        const timeoutCallback = timeoutCallbacksById[id];
        if (timeoutCallback) {
            timeoutCallback();
            timeoutCallbacksById[id] = null;
            return;
        }
        const intervalCallback = intervalCallbacksById[id];
        if (intervalCallback) {
            intervalCallback();
        }
    };
    function setTimeoutWorker(callback, timeout) {
        const id = getId();
        workerPort.postMessage(['setTimeout', id, timeout]);
        timeoutCallbacksById[id] = callback;
        return id;
    }
    function clearTimeoutWorker(id) {
        workerPort.postMessage(['clearTimeout', id]);
        timeoutCallbacksById[id] = null;
    }
    function setIntervalWorker(callback, timeout) {
        const id = getId();
        workerPort.postMessage(['setInterval', id, timeout]);
        intervalCallbacksById[id] = callback;
        return id;
    }
    function clearIntervalWorker(id) {
        workerPort.postMessage(['clearInterval', id]);
        intervalCallbacksById[id] = null;
    }
    return {
        setTimeout: setTimeoutWorker,
        clearTimeout: clearTimeoutWorker,
        setInterval: setIntervalWorker,
        clearInterval: clearIntervalWorker,
    };
}());
exports.default = timer;

});

var initWorker = createCommonjsModule(function (module, exports) {
var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initWorkerAsync = exports.sleepAsync = exports.getOperatingSystem = void 0;


const timer_1$1 = __importDefault(timer_1);
const getOperatingSystem = () => {
    const nVer = navigator.appVersion;
    const nAgt = navigator.userAgent;
    const unknown = '-';
    // system
    let os = unknown;
    const clientStrings = [
        { s: 'Windows 10', r: /(Windows 10.0|Windows NT 10.0)/ },
        { s: 'Windows 8.1', r: /(Windows 8.1|Windows NT 6.3)/ },
        { s: 'Windows 8', r: /(Windows 8|Windows NT 6.2)/ },
        { s: 'Windows 7', r: /(Windows 7|Windows NT 6.1)/ },
        { s: 'Windows Vista', r: /Windows NT 6.0/ },
        { s: 'Windows Server 2003', r: /Windows NT 5.2/ },
        { s: 'Windows XP', r: /(Windows NT 5.1|Windows XP)/ },
        { s: 'Windows 2000', r: /(Windows NT 5.0|Windows 2000)/ },
        { s: 'Windows ME', r: /(Win 9x 4.90|Windows ME)/ },
        { s: 'Windows 98', r: /(Windows 98|Win98)/ },
        { s: 'Windows 95', r: /(Windows 95|Win95|Windows_95)/ },
        { s: 'Windows NT 4.0', r: /(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/ },
        { s: 'Windows CE', r: /Windows CE/ },
        { s: 'Windows 3.11', r: /Win16/ },
        { s: 'Android', r: /Android/ },
        { s: 'Open BSD', r: /OpenBSD/ },
        { s: 'Sun OS', r: /SunOS/ },
        { s: 'Chrome OS', r: /CrOS/ },
        { s: 'Linux', r: /(Linux|X11(?!.*CrOS))/ },
        { s: 'iOS', r: /(iPhone|iPad|iPod)/ },
        { s: 'Mac OS X', r: /Mac OS X/ },
        { s: 'Mac OS', r: /(Mac OS|MacPPC|MacIntel|Mac_PowerPC|Macintosh)/ },
        { s: 'QNX', r: /QNX/ },
        { s: 'UNIX', r: /UNIX/ },
        { s: 'BeOS', r: /BeOS/ },
        { s: 'OS/2', r: /OS\/2/ },
        { s: 'Search Bot', r: /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/ },
    ];
    for (const id in clientStrings) {
        const cs = clientStrings[id];
        if (cs.r.test(nAgt)) {
            os = cs.s;
            break;
        }
    }
    let osVersion = unknown;
    if (/Windows/.test(os)) {
        osVersion = /Windows (.*)/.exec(os)[1];
        os = 'Windows';
    }
    switch (os) {
        case 'Mac OS':
        case 'Mac OS X':
        case 'Android':
            osVersion = /(?:Android|Mac OS|Mac OS X|MacPPC|MacIntel|Mac_PowerPC|Macintosh) ([._\d]+)/.exec(nAgt)[1];
            break;
        case 'iOS': {
            const osVersionArray = /OS (\d+)_(\d+)_?(\d+)?/.exec(nVer);
            osVersion = osVersionArray[1] + '.' + osVersionArray[2] + '.' + (parseInt(osVersionArray[3]) | 0);
            break;
        }
    }
    return {
        os,
        osVersion,
    };
};
exports.getOperatingSystem = getOperatingSystem;
function getBrowser() {
    const ua = navigator.userAgent;
    let tem;
    let M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
        tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
        return { name: 'ie', version: (tem[1] || '') };
    }
    if (M[1] === 'Chrome') {
        tem = ua.match(/\bOPR|Edge\/(\d+)/);
        if (tem != null) {
            let version = tem[1];
            if (!version) {
                const splits = ua.split(tem[0] + '/');
                if (splits.length > 1) {
                    version = splits[1];
                }
            }
            return { name: 'opera', version };
        }
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) {
        M.splice(1, 1, tem[1]);
    }
    return {
        name: M[0].toLowerCase(),
        version: M[1],
    };
}
let keepAliveServiceWorkerTimeoutId = null;
const sleepAsync = (milliseconds) => {
    return new Promise(resolve => timer_1$1.default.setTimeout(resolve, milliseconds));
};
exports.sleepAsync = sleepAsync;
const keepAlive = () => {
    try {
        const promise = fetch('/OidcKeepAliveServiceWorker.json');
        promise.catch(error => { console.log(error); });
        (0, exports.sleepAsync)(230 * 1000).then(keepAlive);
    }
    catch (error) {
        console.log(error);
    }
};
const isServiceWorkerProxyActiveAsync = () => {
    return fetch('/OidcKeepAliveServiceWorker.json', {
        headers: {
            'oidc-vanilla': 'true',
        },
    }).then((response) => {
        return response.statusText === 'oidc-service-worker';
    }).catch(error => { console.log(error); });
};
const sendMessageAsync = (registration) => (data) => {
    return new Promise(function (resolve, reject) {
        const messageChannel = new MessageChannel();
        messageChannel.port1.onmessage = function (event) {
            if (event.data && event.data.error) {
                reject(event.data.error);
            }
            else {
                resolve(event.data);
            }
        };
        registration.active.postMessage(data, [messageChannel.port2]);
    });
};
const initWorkerAsync = (serviceWorkerRelativeUrl, configurationName, redirectUri) => __awaiter(void 0, void 0, void 0, function* () {
    if (typeof window === 'undefined' || typeof navigator === 'undefined' || !navigator.serviceWorker || !serviceWorkerRelativeUrl) {
        return null;
    }
    const { name, version } = getBrowser();
    if (name === 'chrome' && parseInt(version) < 90) {
        return null;
    }
    if (name === 'opera') {
        if (!version) {
            return null;
        }
        if (parseInt(version.split('.')[0]) < 80) {
            return null;
        }
    }
    if (name === 'ie') {
        return null;
    }
    const operatingSystem = (0, exports.getOperatingSystem)();
    const registration = yield navigator.serviceWorker.register(serviceWorkerRelativeUrl);
    try {
        yield navigator.serviceWorker.ready;
    }
    catch (err) {
        return null;
    }
    const unregisterAsync = () => __awaiter(void 0, void 0, void 0, function* () {
        return yield registration.unregister();
    });
    const saveItemsAsync = (items) => {
        // iOS kill Service Worker when domain we leave domain
        if (operatingSystem.os === 'iOS') {
            const session = (0, initSession_1.initSession)(configurationName, redirectUri);
            return session.saveItemsAsync(items);
        }
        return sendMessageAsync(registration)({ type: 'saveItems', data: items, configurationName });
    };
    const loadItemsAsync = () => {
        // iOS kill Service Worker when domain we leave domain
        if (operatingSystem.os === 'iOS') {
            const session = (0, initSession_1.initSession)(configurationName, redirectUri);
            return session.loadItemsAsync();
        }
        return sendMessageAsync(registration)({ type: 'loadItems', data: null, configurationName });
    };
    const clearAsync = (status) => __awaiter(void 0, void 0, void 0, function* () {
        // iOS kill Service Worker when domain we leave domain
        if (operatingSystem.os === 'iOS') {
            const session = (0, initSession_1.initSession)(configurationName, redirectUri);
            yield session.clearAsync(status);
        }
        return sendMessageAsync(registration)({ type: 'clear', data: { status }, configurationName });
    });
    const initAsync = (oidcServerConfiguration, where, oidcConfiguration) => __awaiter(void 0, void 0, void 0, function* () {
        const result = yield sendMessageAsync(registration)({
            type: 'init',
            data: { oidcServerConfiguration, where, oidcConfiguration },
            configurationName,
        });
        // @ts-ignore
        return { tokens: (0, parseTokens.parseOriginalTokens)(result.tokens, null, oidcConfiguration.token_renew_mode), status: result.status };
    });
    const startKeepAliveServiceWorker = () => {
        if (keepAliveServiceWorkerTimeoutId == null) {
            keepAliveServiceWorkerTimeoutId = 'not_null';
            keepAlive();
        }
    };
    const setSessionStateAsync = (sessionState) => {
        return sendMessageAsync(registration)({ type: 'setSessionState', data: { sessionState }, configurationName });
    };
    const getSessionStateAsync = () => __awaiter(void 0, void 0, void 0, function* () {
        const result = yield sendMessageAsync(registration)({ type: 'getSessionState', data: null, configurationName });
        // @ts-ignore
        return result.sessionState;
    });
    const setNonceAsync = (nonce) => {
        // iOS kill Service Worker when domain we leave domain
        if (operatingSystem.os === 'iOS') {
            const session = (0, initSession_1.initSession)(configurationName, redirectUri);
            return session.setNonceAsync(nonce);
        }
        return sendMessageAsync(registration)({ type: 'setNonce', data: { nonce }, configurationName });
    };
    const NONCE_TOKEN = 'NONCE_SECURED_BY_OIDC_SERVICE_WORKER';
    const getNonceAsync = () => __awaiter(void 0, void 0, void 0, function* () {
        // iOS kill Service Worker when domain we leave domain
        if (operatingSystem.os === 'iOS') {
            const session = (0, initSession_1.initSession)(configurationName, redirectUri);
            return session.getNonceAsync();
        }
        // @ts-ignore
        const keyNonce = NONCE_TOKEN + '_' + configurationName;
        return { nonce: keyNonce };
    });
    return {
        saveItemsAsync,
        loadItemsAsync,
        clearAsync,
        initAsync,
        startKeepAliveServiceWorker,
        isServiceWorkerProxyActiveAsync,
        setSessionStateAsync,
        getSessionStateAsync,
        setNonceAsync,
        getNonceAsync,
        unregisterAsync,
    };
});
exports.initWorkerAsync = initWorkerAsync;

});

var memoryStorageBackend = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.MemoryStorageBackend = void 0;
class MemoryStorageBackend {
    constructor(saveItemsAsync, items = {}) {
        this.items = items;
        this.saveItemsAsync = saveItemsAsync;
        this.saveItemsAsync.bind(this);
        this.getItem.bind(this);
        this.removeItem.bind(this);
        this.clear.bind(this);
        this.setItem.bind(this);
    }
    getItem(name) {
        return Promise.resolve(this.items[name]);
    }
    removeItem(name) {
        delete this.items[name];
        return this.saveItemsAsync(this.items);
    }
    clear() {
        this.items = {};
        return this.saveItemsAsync(this.items);
    }
    setItem(name, value) {
        this.items[name] = value;
        return this.saveItemsAsync(this.items);
    }
}
exports.MemoryStorageBackend = MemoryStorageBackend;

});

var noHashQueryStringUtils = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.HashQueryStringUtils = exports.NoHashQueryStringUtils = void 0;

class NoHashQueryStringUtils extends built.BasicQueryStringUtils {
    parse(input, _useHash) {
        return super.parse(input, false /* never use hash */);
    }
}
exports.NoHashQueryStringUtils = NoHashQueryStringUtils;
const keys = ['code', 'session_state', 'state'];
class HashQueryStringUtils extends built.BasicQueryStringUtils {
    parse(input, _useHash) {
        const output = super.parse(input, true /* use hash */);
        // Fix AppAuthJs behavior
        let propertyToDelelete = null;
        Object.entries(output).forEach(([key, value]) => {
            keys.forEach(k => {
                if (key.endsWith(`?${k}`)) {
                    output[k] = value;
                    propertyToDelelete = key;
                }
            });
        });
        if (propertyToDelelete) {
            delete output[propertyToDelelete];
        }
        return output;
    }
}
exports.HashQueryStringUtils = HashQueryStringUtils;

});

var routeUtils = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.getParseQueryStringFromLocation = exports.getPath = exports.getLocation = void 0;
const getLocation = (href) => {
    const match = href.match(
    // eslint-disable-next-line no-useless-escape
    /^(https?\:)\/\/(([^:\/?#]*)(?:\:([0-9]+))?)([\/]{0,1}[^?#]*)(\?[^#]*|)(#.*|)$/);
    let search = match[6];
    let hash = match[7];
    if (hash) {
        const splits = hash.split('?');
        if (splits.length === 2) {
            hash = splits[0];
            search = splits[1];
        }
    }
    if (search) {
        search = search.slice(1);
    }
    return (match && {
        href,
        protocol: match[1],
        host: match[2],
        hostname: match[3],
        port: match[4],
        path: match[5],
        search,
        hash,
    });
};
exports.getLocation = getLocation;
const getPath = (href) => {
    const location = (0, exports.getLocation)(href);
    let { path } = location;
    if (path.endsWith('/')) {
        path = path.slice(0, -1);
    }
    let { hash } = location;
    if (hash === '#_=_') {
        hash = '';
    }
    if (hash) {
        path += hash;
    }
    return path;
};
exports.getPath = getPath;
const getParseQueryStringFromLocation = (href) => {
    const location = (0, exports.getLocation)(href);
    const { search } = location;
    return parseQueryString(search);
};
exports.getParseQueryStringFromLocation = getParseQueryStringFromLocation;
const parseQueryString = (queryString) => {
    const params = {};
    let temp;
    let i;
    let l;
    // Split into key/value pairs
    const queries = queryString.split('&');
    // Convert the array of strings into an object
    for (i = 0, l = queries.length; i < l; i++) {
        temp = queries[i].split('=');
        params[temp[0]] = temp[1];
    }
    return params;
};

});

var oidc_1 = createCommonjsModule(function (module, exports) {
var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Oidc = exports.OidcAuthorizationServiceConfiguration = void 0;








const timer_1$1 = __importDefault(timer_1);
const TOKEN_TYPE = {
    refresh_token: 'refresh_token',
    access_token: 'access_token',
};
const performRevocationRequestAsync = (url, token, token_type = TOKEN_TYPE.refresh_token, client_id, timeoutMs = 10000) => __awaiter(void 0, void 0, void 0, function* () {
    const details = {
        token,
        token_type_hint: token_type,
        client_id,
    };
    const formBody = [];
    for (const property in details) {
        const encodedKey = encodeURIComponent(property);
        const encodedValue = encodeURIComponent(details[property]);
        formBody.push(`${encodedKey}=${encodedValue}`);
    }
    const formBodyString = formBody.join('&');
    const response = yield internalFetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
        },
        body: formBodyString,
    }, timeoutMs);
    if (response.status !== 200) {
        return { success: false };
    }
    return {
        success: true,
    };
});
const performTokenRequestAsync = (url, details, extras, oldTokens, tokenRenewMode, timeoutMs = 10000) => __awaiter(void 0, void 0, void 0, function* () {
    for (const [key, value] of Object.entries(extras)) {
        if (details[key] === undefined) {
            details[key] = value;
        }
    }
    const formBody = [];
    for (const property in details) {
        const encodedKey = encodeURIComponent(property);
        const encodedValue = encodeURIComponent(details[property]);
        formBody.push(`${encodedKey}=${encodedValue}`);
    }
    const formBodyString = formBody.join('&');
    const response = yield internalFetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
        },
        body: formBodyString,
    }, timeoutMs);
    if (response.status !== 200) {
        return { success: false, status: response.status };
    }
    const tokens = yield response.json();
    return {
        success: true,
        data: (0, parseTokens.parseOriginalTokens)(tokens, oldTokens, tokenRenewMode),
    };
});
const internalFetch = (url, headers, numberRetry = 0, timeoutMs = 10000) => __awaiter(void 0, void 0, void 0, function* () {
    let response;
    try {
        const controller = new AbortController();
        setTimeout(() => controller.abort(), timeoutMs);
        response = yield fetch(url, Object.assign(Object.assign({}, headers), { signal: controller.signal }));
    }
    catch (e) {
        if (e.message === 'AbortError' ||
            e.message === 'Network request failed') {
            if (numberRetry <= 1) {
                return yield internalFetch(url, headers, numberRetry + 1, timeoutMs);
            }
            else {
                throw e;
            }
        }
        else {
            console.error(e.message);
            throw e; // rethrow other unexpected errors
        }
    }
    return response;
});
const randomString = function (length) {
    let text = '';
    const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    for (let i = 0; i < length; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
};
class OidcAuthorizationServiceConfiguration extends built.AuthorizationServiceConfiguration {
    constructor(request) {
        super(request);
        this.authorizationEndpoint = request.authorization_endpoint;
        this.tokenEndpoint = request.token_endpoint;
        this.revocationEndpoint = request.revocation_endpoint;
        this.userInfoEndpoint = request.userinfo_endpoint;
        this.check_session_iframe = request.check_session_iframe;
        this.issuer = request.issuer;
    }
}
exports.OidcAuthorizationServiceConfiguration = OidcAuthorizationServiceConfiguration;
const oidcDatabase = {};
const oidcFactory = (configuration, name = 'default') => {
    if (oidcDatabase[name]) {
        return oidcDatabase[name];
    }
    oidcDatabase[name] = new Oidc(configuration, name);
    return oidcDatabase[name];
};
const loginCallbackWithAutoTokensRenewAsync = (oidc) => __awaiter(void 0, void 0, void 0, function* () {
    const { parsedTokens, callbackPath } = yield oidc.loginCallbackAsync();
    oidc.timeoutId = autoRenewTokens(oidc, parsedTokens.refreshToken, parsedTokens.expiresAt);
    return { callbackPath };
});
function renewTokensAndStartTimerAsync(oidc, refreshToken, forceRefresh = false, extras = null) {
    return __awaiter(this, void 0, void 0, function* () {
        const updateTokens = (tokens) => { oidc.tokens = tokens; };
        const { tokens, status } = yield oidc.synchroniseTokensAsync(refreshToken, 0, forceRefresh, extras, updateTokens);
        const serviceWorker = yield (0, initWorker.initWorkerAsync)(oidc.configuration.service_worker_relative_url, oidc.configurationName, oidc.configuration.redirect_uri);
        if (!serviceWorker) {
            const session = (0, initSession_1.initSession)(oidc.configurationName, oidc.configuration.redirect_uri, oidc.configuration.storage);
            yield session.setTokens(oidc.tokens);
        }
        if (!oidc.tokens) {
            yield oidc.destroyAsync(status);
            return;
        }
        if (oidc.timeoutId) {
            oidc.timeoutId = autoRenewTokens(oidc, tokens.refreshToken, oidc.tokens.expiresAt, extras);
        }
    });
}
const autoRenewTokens = (oidc, refreshToken, expiresAt, extras = null) => {
    const refreshTimeBeforeTokensExpirationInSecond = oidc.configuration.refresh_time_before_tokens_expiration_in_second;
    return timer_1$1.default.setTimeout(() => __awaiter(void 0, void 0, void 0, function* () {
        const timeLeft = (0, parseTokens.computeTimeLeft)(refreshTimeBeforeTokensExpirationInSecond, expiresAt);
        const timeInfo = { timeLeft };
        oidc.publishEvent(Oidc.eventNames.token_timer, timeInfo);
        yield renewTokensAndStartTimerAsync(oidc, refreshToken, false, extras);
    }), 1000);
};
const getLoginSessionKey = (configurationName, redirectUri) => {
    return `oidc_login.${configurationName}:${redirectUri}`;
};
const setLoginParams = (configurationName, redirectUri, data) => {
    const sessionKey = getLoginSessionKey(configurationName, redirectUri);
    getLoginParamsCache = data;
    sessionStorage[sessionKey] = JSON.stringify(data);
};
let getLoginParamsCache = null;
const getLoginParams = (configurationName, redirectUri) => {
    const dataString = sessionStorage[getLoginSessionKey(configurationName, redirectUri)];
    if (!getLoginParamsCache) {
        getLoginParamsCache = JSON.parse(dataString);
    }
    return getLoginParamsCache;
};
const userInfoAsync = (oidc) => __awaiter(void 0, void 0, void 0, function* () {
    if (oidc.userInfo != null) {
        return oidc.userInfo;
    }
    if (!oidc.tokens) {
        return null;
    }
    const accessToken = oidc.tokens.accessToken;
    if (!accessToken) {
        return null;
    }
    // We wait the synchronisation before making a request
    while (oidc.tokens && !(0, parseTokens.isTokensValid)(oidc.tokens)) {
        yield (0, initWorker.sleepAsync)(200);
    }
    const oidcServerConfiguration = yield oidc.initAsync(oidc.configuration.authority, oidc.configuration.authority_configuration);
    const url = oidcServerConfiguration.userInfoEndpoint;
    const fetchUserInfo = (accessToken) => __awaiter(void 0, void 0, void 0, function* () {
        const res = yield fetch(url, {
            headers: {
                authorization: `Bearer ${accessToken}`,
            },
        });
        if (res.status !== 200) {
            return null;
        }
        return res.json();
    });
    const userInfo = yield fetchUserInfo(accessToken);
    oidc.userInfo = userInfo;
    return userInfo;
});
const eventNames = {
    service_worker_not_supported_by_browser: 'service_worker_not_supported_by_browser',
    token_aquired: 'token_aquired',
    logout_from_another_tab: 'logout_from_another_tab',
    logout_from_same_tab: 'logout_from_same_tab',
    token_renewed: 'token_renewed',
    token_timer: 'token_timer',
    loginAsync_begin: 'loginAsync_begin',
    loginAsync_error: 'loginAsync_error',
    loginCallbackAsync_begin: 'loginCallbackAsync_begin',
    loginCallbackAsync_end: 'loginCallbackAsync_end',
    loginCallbackAsync_error: 'loginCallbackAsync_error',
    refreshTokensAsync_begin: 'refreshTokensAsync_begin',
    refreshTokensAsync: 'refreshTokensAsync',
    refreshTokensAsync_end: 'refreshTokensAsync_end',
    refreshTokensAsync_error: 'refreshTokensAsync_error',
    refreshTokensAsync_silent_error: 'refreshTokensAsync_silent_error',
    tryKeepExistingSessionAsync_begin: 'tryKeepExistingSessionAsync_begin',
    tryKeepExistingSessionAsync_end: 'tryKeepExistingSessionAsync_end',
    tryKeepExistingSessionAsync_error: 'tryKeepExistingSessionAsync_error',
    silentLoginAsync_begin: 'silentLoginAsync_begin',
    silentLoginAsync: 'silentLoginAsync',
    silentLoginAsync_end: 'silentLoginAsync_end',
    silentLoginAsync_error: 'silentLoginAsync_error',
    syncTokensAsync_begin: 'syncTokensAsync_begin',
    syncTokensAsync_end: 'syncTokensAsync_end',
    syncTokensAsync_error: 'syncTokensAsync_error',
};
const getRandomInt = (max) => {
    return Math.floor(Math.random() * max);
};
const oneHourSecond = 60 * 60;
const fetchFromIssuerCache = {};
const fetchFromIssuer = (openIdIssuerUrl, timeCacheSecond = oneHourSecond, storage = window.sessionStorage) => __awaiter(void 0, void 0, void 0, function* () {
    const fullUrl = `${openIdIssuerUrl}/.well-known/openid-configuration`;
    const localStorageKey = `oidc.server:${openIdIssuerUrl}`;
    if (!fetchFromIssuerCache[localStorageKey]) {
        if (storage) {
            const cacheJson = storage.getItem(localStorageKey);
            if (cacheJson) {
                fetchFromIssuerCache[localStorageKey] = JSON.parse(cacheJson);
            }
        }
    }
    const oneHourMinisecond = 1000 * timeCacheSecond;
    // @ts-ignore
    if (fetchFromIssuerCache[localStorageKey] && (fetchFromIssuerCache[localStorageKey].timestamp + oneHourMinisecond) > Date.now()) {
        return new OidcAuthorizationServiceConfiguration(fetchFromIssuerCache[localStorageKey].result);
    }
    const response = yield fetch(fullUrl);
    if (response.status !== 200) {
        return null;
    }
    const result = yield response.json();
    const timestamp = Date.now();
    fetchFromIssuerCache[localStorageKey] = { result, timestamp };
    if (storage) {
        storage.setItem(localStorageKey, JSON.stringify({ result, timestamp }));
    }
    return new OidcAuthorizationServiceConfiguration(result);
});
class Oidc {
    constructor(configuration, configurationName = 'default') {
        var _a, _b, _c, _d;
        this.initPromise = null;
        this.tryKeepExistingSessionPromise = null;
        this.loginPromise = null;
        this.loginCallbackPromise = null;
        this.loginCallbackWithAutoTokensRenewPromise = null;
        this.userInfoPromise = null;
        let silent_login_uri = configuration.silent_login_uri;
        if (configuration.silent_redirect_uri && !configuration.silent_login_uri) {
            silent_login_uri = `${configuration.silent_redirect_uri.replace('-callback', '').replace('callback', '')}-login`;
        }
        this.configuration = Object.assign(Object.assign({}, configuration), { silent_login_uri, monitor_session: (_a = configuration.monitor_session) !== null && _a !== void 0 ? _a : false, refresh_time_before_tokens_expiration_in_second: (_b = configuration.refresh_time_before_tokens_expiration_in_second) !== null && _b !== void 0 ? _b : 60, silent_login_timeout: (_c = configuration.silent_login_timeout) !== null && _c !== void 0 ? _c : 12000, token_renew_mode: (_d = configuration.token_renew_mode) !== null && _d !== void 0 ? _d : parseTokens.TokenRenewMode.access_token_or_id_token_invalid });
        this.configurationName = configurationName;
        this.tokens = null;
        this.userInfo = null;
        this.events = [];
        this.timeoutId = null;
        this.synchroniseTokensAsync.bind(this);
        this.loginCallbackWithAutoTokensRenewAsync.bind(this);
        this.initAsync.bind(this);
        this.loginCallbackAsync.bind(this);
        this._loginCallbackAsync.bind(this);
        this.subscribeEvents.bind(this);
        this.removeEventSubscription.bind(this);
        this.publishEvent.bind(this);
        this.destroyAsync.bind(this);
        this.logoutAsync.bind(this);
        this.renewTokensAsync.bind(this);
        this.initAsync(this.configuration.authority, this.configuration.authority_configuration);
    }
    subscribeEvents(func) {
        const id = getRandomInt(9999999999999).toString();
        this.events.push({ id, func });
        return id;
    }
    removeEventSubscription(id) {
        const newEvents = this.events.filter(e => e.id !== id);
        this.events = newEvents;
    }
    publishEvent(eventName, data) {
        this.events.forEach(event => {
            event.func(eventName, data);
        });
    }
    static getOrCreate(configuration, name = 'default') {
        return oidcFactory(configuration, name);
    }
    static get(name = 'default') {
        const isInsideBrowser = (typeof process === 'undefined');
        if (!Object.prototype.hasOwnProperty.call(oidcDatabase, name) && isInsideBrowser) {
            throw Error(`OIDC library does seem initialized.
Please checkout that you are using OIDC hook inside a <OidcProvider configurationName="${name}"></OidcProvider> compoment.`);
        }
        return oidcDatabase[name];
    }
    _silentLoginCallbackFromIFrame() {
        if (this.configuration.silent_redirect_uri && this.configuration.silent_login_uri) {
            const queryParams = (0, routeUtils.getParseQueryStringFromLocation)(window.location.href);
            window.top.postMessage(`${this.configurationName}_oidc_tokens:${JSON.stringify({ tokens: this.tokens, sessionState: queryParams.session_state })}`, window.location.origin);
        }
    }
    _silentLoginErrorCallbackFromIFrame() {
        if (this.configuration.silent_redirect_uri && this.configuration.silent_login_uri) {
            const queryParams = (0, routeUtils.getParseQueryStringFromLocation)(window.location.href);
            window.top.postMessage(`${this.configurationName}_oidc_error:${JSON.stringify({ error: queryParams.error })}`, window.location.origin);
        }
    }
    silentLoginCallbackAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield this.loginCallbackAsync(true);
                this._silentLoginCallbackFromIFrame();
            }
            catch (error) {
                console.error(error);
                this._silentLoginErrorCallbackFromIFrame();
            }
        });
    }
    silentLoginAsync(extras = null, state = null, scope = null) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.configuration.silent_redirect_uri || !this.configuration.silent_login_uri) {
                return Promise.resolve(null);
            }
            try {
                this.publishEvent(eventNames.silentLoginAsync_begin, {});
                const configuration = this.configuration;
                let queries = '';
                if (state) {
                    if (extras == null) {
                        extras = {};
                    }
                    extras.state = state;
                }
                if (scope) {
                    if (extras == null) {
                        extras = {};
                    }
                    extras.scope = scope;
                }
                if (extras != null) {
                    for (const [key, value] of Object.entries(extras)) {
                        if (queries === '') {
                            queries = `?${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
                        }
                        else {
                            queries += `&${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
                        }
                    }
                }
                const link = configuration.silent_login_uri + queries;
                const idx = link.indexOf('/', link.indexOf('//') + 2);
                const iFrameOrigin = link.substr(0, idx);
                const iframe = document.createElement('iframe');
                iframe.width = '0px';
                iframe.height = '0px';
                iframe.id = `${this.configurationName}_oidc_iframe`;
                iframe.setAttribute('src', link);
                document.body.appendChild(iframe);
                return new Promise((resolve, reject) => {
                    try {
                        let isResolved = false;
                        window.onmessage = (e) => {
                            if (e.origin === iFrameOrigin &&
                                e.source === iframe.contentWindow) {
                                const key = `${this.configurationName}_oidc_tokens:`;
                                const key_error = `${this.configurationName}_oidc_error:`;
                                const data = e.data;
                                if (data && typeof (data) === 'string') {
                                    if (!isResolved) {
                                        if (data.startsWith(key)) {
                                            const result = JSON.parse(e.data.replace(key, ''));
                                            this.publishEvent(eventNames.silentLoginAsync_end, {});
                                            iframe.remove();
                                            isResolved = true;
                                            resolve(result);
                                        }
                                        else if (data.startsWith(key_error)) {
                                            const result = JSON.parse(e.data.replace(key_error, ''));
                                            this.publishEvent(eventNames.silentLoginAsync_error, result);
                                            iframe.remove();
                                            isResolved = true;
                                            reject(new Error('oidc_' + result.error));
                                        }
                                    }
                                }
                            }
                        };
                        const silentSigninTimeout = configuration.silent_login_timeout;
                        setTimeout(() => {
                            if (!isResolved) {
                                this.publishEvent(eventNames.silentLoginAsync_error, { reason: 'timeout' });
                                iframe.remove();
                                isResolved = true;
                                reject(new Error('timeout'));
                            }
                        }, silentSigninTimeout);
                    }
                    catch (e) {
                        iframe.remove();
                        this.publishEvent(eventNames.silentLoginAsync_error, e);
                        reject(e);
                    }
                });
            }
            catch (e) {
                this.publishEvent(eventNames.silentLoginAsync_error, e);
                throw e;
            }
        });
    }
    initAsync(authority, authorityConfiguration) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.initPromise !== null) {
                return this.initPromise;
            }
            const localFuncAsync = () => __awaiter(this, void 0, void 0, function* () {
                var _a;
                if (authorityConfiguration != null) {
                    return new OidcAuthorizationServiceConfiguration({
                        authorization_endpoint: authorityConfiguration.authorization_endpoint,
                        end_session_endpoint: authorityConfiguration.end_session_endpoint,
                        revocation_endpoint: authorityConfiguration.revocation_endpoint,
                        token_endpoint: authorityConfiguration.token_endpoint,
                        userinfo_endpoint: authorityConfiguration.userinfo_endpoint,
                        check_session_iframe: authorityConfiguration.check_session_iframe,
                        issuer: authorityConfiguration.issuer,
                    });
                }
                const serviceWorker = yield (0, initWorker.initWorkerAsync)(this.configuration.service_worker_relative_url, this.configurationName, this.configuration.redirect_uri);
                const storage = serviceWorker ? window.localStorage : null;
                return yield fetchFromIssuer(authority, (_a = this.configuration.authority_time_cache_wellknowurl_in_second) !== null && _a !== void 0 ? _a : 60 * 60, storage);
            });
            this.initPromise = localFuncAsync();
            return this.initPromise.then((result) => {
                this.initPromise = null;
                return result;
            });
        });
    }
    tryKeepExistingSessionAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.tryKeepExistingSessionPromise !== null) {
                return this.tryKeepExistingSessionPromise;
            }
            const funcAsync = () => __awaiter(this, void 0, void 0, function* () {
                var _a;
                let serviceWorker;
                if (this.tokens != null) {
                    return false;
                }
                this.publishEvent(eventNames.tryKeepExistingSessionAsync_begin, {});
                try {
                    const configuration = this.configuration;
                    const oidcServerConfiguration = yield this.initAsync(configuration.authority, configuration.authority_configuration);
                    serviceWorker = yield (0, initWorker.initWorkerAsync)(configuration.service_worker_relative_url, this.configurationName, configuration.redirect_uri);
                    if (serviceWorker) {
                        const { tokens } = yield serviceWorker.initAsync(oidcServerConfiguration, 'tryKeepExistingSessionAsync', configuration);
                        if (tokens) {
                            serviceWorker.startKeepAliveServiceWorker();
                            // @ts-ignore
                            this.tokens = tokens;
                            // @ts-ignore
                            this.timeoutId = autoRenewTokens(this, this.tokens.refreshToken, this.tokens.expiresAt);
                            const sessionState = yield serviceWorker.getSessionStateAsync();
                            // @ts-ignore
                            yield this.startCheckSessionAsync(oidcServerConfiguration.check_session_iframe, configuration.client_id, sessionState);
                            this.publishEvent(eventNames.tryKeepExistingSessionAsync_end, {
                                success: true,
                                message: 'tokens inside ServiceWorker are valid',
                            });
                            return true;
                        }
                        this.publishEvent(eventNames.tryKeepExistingSessionAsync_end, {
                            success: false,
                            message: 'no exiting session found',
                        });
                    }
                    else {
                        if (configuration.service_worker_relative_url) {
                            this.publishEvent(eventNames.service_worker_not_supported_by_browser, {
                                message: 'service worker is not supported by this browser',
                            });
                        }
                        const session = (0, initSession_1.initSession)(this.configurationName, configuration.redirect_uri, (_a = configuration.storage) !== null && _a !== void 0 ? _a : sessionStorage);
                        const { tokens } = yield session.initAsync();
                        if (tokens) {
                            // @ts-ignore
                            this.tokens = (0, parseTokens.setTokens)(tokens, null, configuration.token_renew_mode);
                            // @ts-ignore
                            this.timeoutId = autoRenewTokens(this, tokens.refreshToken, this.tokens.expiresAt);
                            const sessionState = session.getSessionState();
                            // @ts-ignore
                            yield this.startCheckSessionAsync(oidcServerConfiguration.check_session_iframe, configuration.client_id, sessionState);
                            this.publishEvent(eventNames.tryKeepExistingSessionAsync_end, {
                                success: true,
                                message: 'tokens inside storage are valid',
                            });
                            return true;
                        }
                    }
                    this.publishEvent(eventNames.tryKeepExistingSessionAsync_end, {
                        success: false,
                        message: serviceWorker ? 'service worker sessions not retrieved' : 'session storage sessions not retrieved',
                    });
                    return false;
                }
                catch (exception) {
                    console.error(exception);
                    if (serviceWorker) {
                        yield serviceWorker.clearAsync();
                    }
                    this.publishEvent(eventNames.tryKeepExistingSessionAsync_error, 'tokens inside ServiceWorker are invalid');
                    return false;
                }
            });
            this.tryKeepExistingSessionPromise = funcAsync();
            return this.tryKeepExistingSessionPromise.then((result) => {
                this.tryKeepExistingSessionPromise = null;
                return result;
            });
        });
    }
    loginAsync(callbackPath = undefined, extras = null, isSilentSignin = false, scope = undefined, silentLoginOnly = false) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.loginPromise !== null) {
                return this.loginPromise;
            }
            const loginLocalAsync = () => __awaiter(this, void 0, void 0, function* () {
                var _a, _b;
                const location = window.location;
                const url = callbackPath || location.pathname + (location.search || '') + (location.hash || '');
                const configuration = this.configuration;
                let state;
                if (extras && 'state' in extras) {
                    state = extras.state;
                    delete extras.state;
                }
                if (silentLoginOnly) {
                    try {
                        const extraFinal = (_a = extras !== null && extras !== void 0 ? extras : configuration.extras) !== null && _a !== void 0 ? _a : {};
                        const silentResult = yield this.silentLoginAsync(Object.assign(Object.assign({}, extraFinal), { prompt: 'none' }), state, scope);
                        if (silentResult) {
                            this.tokens = silentResult.tokens;
                            this.publishEvent(eventNames.token_aquired, {});
                            // @ts-ignore
                            this.timeoutId = autoRenewTokens(this, this.tokens.refreshToken, this.tokens.expiresAt, extras);
                            return {};
                        }
                    }
                    catch (e) {
                        return e;
                    }
                }
                this.publishEvent(eventNames.loginAsync_begin, {});
                try {
                    const redirectUri = isSilentSignin ? configuration.silent_redirect_uri : configuration.redirect_uri;
                    if (!scope) {
                        scope = configuration.scope;
                    }
                    setLoginParams(this.configurationName, redirectUri, { callbackPath: url, extras, state });
                    const extraFinal = (_b = extras !== null && extras !== void 0 ? extras : configuration.extras) !== null && _b !== void 0 ? _b : {};
                    if (!extraFinal.nonce) {
                        extraFinal.nonce = randomString(12);
                    }
                    const nonce = { nonce: extraFinal.nonce };
                    const serviceWorker = yield (0, initWorker.initWorkerAsync)(configuration.service_worker_relative_url, this.configurationName, this.configuration.redirect_uri);
                    const oidcServerConfiguration = yield this.initAsync(configuration.authority, configuration.authority_configuration);
                    let storage;
                    if (serviceWorker) {
                        serviceWorker.startKeepAliveServiceWorker();
                        yield serviceWorker.initAsync(oidcServerConfiguration, 'loginAsync', configuration);
                        yield serviceWorker.setNonceAsync(nonce);
                        storage = new memoryStorageBackend.MemoryStorageBackend(serviceWorker.saveItemsAsync, {});
                        yield storage.setItem('dummy', {});
                    }
                    else {
                        const session = (0, initSession_1.initSession)(this.configurationName, redirectUri);
                        yield session.setNonceAsync(nonce);
                        storage = new memoryStorageBackend.MemoryStorageBackend(session.saveItemsAsync, {});
                    }
                    // @ts-ignore
                    const queryStringUtil = redirectUri.includes('#') ? new noHashQueryStringUtils.HashQueryStringUtils() : new noHashQueryStringUtils.NoHashQueryStringUtils();
                    const authorizationHandler = new built.RedirectRequestHandler(storage, queryStringUtil, window.location, new built.DefaultCrypto());
                    const authRequest = new built.AuthorizationRequest({
                        client_id: configuration.client_id,
                        redirect_uri: redirectUri,
                        scope,
                        response_type: built.AuthorizationRequest.RESPONSE_TYPE_CODE,
                        state,
                        extras: extraFinal,
                    });
                    authorizationHandler.performAuthorizationRequest(oidcServerConfiguration, authRequest);
                }
                catch (exception) {
                    this.publishEvent(eventNames.loginAsync_error, exception);
                    throw exception;
                }
            });
            this.loginPromise = loginLocalAsync();
            return this.loginPromise.then(result => {
                this.loginPromise = null;
                return result;
            });
        });
    }
    startCheckSessionAsync(checkSessionIFrameUri, clientId, sessionState, isSilentSignin = false) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                if (this.configuration.silent_login_uri && this.configuration.silent_redirect_uri && this.configuration.monitor_session && checkSessionIFrameUri && sessionState && !isSilentSignin) {
                    const checkSessionCallback = () => {
                        this.checkSessionIFrame.stop();
                        if (this.tokens === null) {
                            return;
                        }
                        // @ts-ignore
                        const idToken = this.tokens.idToken;
                        // @ts-ignore
                        const idTokenPayload = this.tokens.idTokenPayload;
                        this.silentLoginAsync({
                            prompt: 'none',
                            id_token_hint: idToken,
                            scope: 'openid',
                        }).then((silentSigninResponse) => {
                            const iFrameIdTokenPayload = silentSigninResponse.tokens.idTokenPayload;
                            if (idTokenPayload.sub === iFrameIdTokenPayload.sub) {
                                const sessionState = silentSigninResponse.sessionState;
                                this.checkSessionIFrame.start(silentSigninResponse.sessionState);
                                if (idTokenPayload.sid === iFrameIdTokenPayload.sid) {
                                    console.debug('SessionMonitor._callback: Same sub still logged in at OP, restarting check session iframe; session_state:', sessionState);
                                }
                                else {
                                    console.debug('SessionMonitor._callback: Same sub still logged in at OP, session state has changed, restarting check session iframe; session_state:', sessionState);
                                }
                            }
                            else {
                                console.debug('SessionMonitor._callback: Different subject signed into OP:', iFrameIdTokenPayload.sub);
                            }
                            // eslint-disable-next-line @typescript-eslint/no-unused-vars
                        }).catch((e) => __awaiter(this, void 0, void 0, function* () {
                            // eslint-disable-next-line @typescript-eslint/no-unused-vars
                            for (const [key, oidc] of Object.entries(oidcDatabase)) {
                                // @ts-ignore
                                yield oidc.logoutOtherTabAsync(this.configuration.client_id, idTokenPayload.sub);
                            }
                        }));
                    };
                    this.checkSessionIFrame = new checkSessionIFrame.CheckSessionIFrame(checkSessionCallback, clientId, checkSessionIFrameUri);
                    this.checkSessionIFrame.load().then(() => {
                        this.checkSessionIFrame.start(sessionState);
                        resolve();
                    }).catch((e) => {
                        reject(e);
                    });
                }
                else {
                    resolve();
                }
            });
        });
    }
    loginCallbackAsync(isSilenSignin = false) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.loginCallbackPromise !== null) {
                return this.loginCallbackPromise;
            }
            const loginCallbackLocalAsync = () => __awaiter(this, void 0, void 0, function* () {
                const response = yield this._loginCallbackAsync(isSilenSignin);
                // @ts-ignore
                const parsedTokens = response.tokens;
                // @ts-ignore
                this.tokens = response.tokens;
                const serviceWorker = yield (0, initWorker.initWorkerAsync)(this.configuration.service_worker_relative_url, this.configurationName, this.configuration.redirect_uri);
                if (!serviceWorker) {
                    const session = (0, initSession_1.initSession)(this.configurationName, this.configuration.redirect_uri, this.configuration.storage);
                    session.setTokens(parsedTokens);
                }
                this.publishEvent(Oidc.eventNames.token_aquired, parsedTokens);
                // @ts-ignore
                return { parsedTokens, state: response.state, callbackPath: response.callbackPath };
            });
            this.loginCallbackPromise = loginCallbackLocalAsync();
            return this.loginCallbackPromise.then(result => {
                this.loginCallbackPromise = null;
                return result;
            });
        });
    }
    _loginCallbackAsync(isSilentSignin = false) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this.publishEvent(eventNames.loginCallbackAsync_begin, {});
                const configuration = this.configuration;
                const clientId = configuration.client_id;
                const redirectUri = isSilentSignin ? configuration.silent_redirect_uri : configuration.redirect_uri;
                const authority = configuration.authority;
                const tokenRequestTimeout = configuration.token_request_timeout;
                const oidcServerConfiguration = yield this.initAsync(authority, configuration.authority_configuration);
                const queryParams = (0, routeUtils.getParseQueryStringFromLocation)(window.location.href);
                const sessionState = queryParams.session_state;
                const serviceWorker = yield (0, initWorker.initWorkerAsync)(configuration.service_worker_relative_url, this.configurationName, configuration.redirect_uri);
                let storage = null;
                let nonceData = null;
                if (serviceWorker) {
                    serviceWorker.startKeepAliveServiceWorker();
                    yield serviceWorker.initAsync(oidcServerConfiguration, 'loginCallbackAsync', configuration);
                    const items = yield serviceWorker.loadItemsAsync();
                    storage = new memoryStorageBackend.MemoryStorageBackend(serviceWorker.saveItemsAsync, items);
                    const dummy = yield storage.getItem('dummy');
                    if (!dummy) {
                        throw new Error('Service Worker storage disapear');
                    }
                    yield storage.removeItem('dummy');
                    yield serviceWorker.setSessionStateAsync(sessionState);
                    nonceData = yield serviceWorker.getNonceAsync();
                }
                else {
                    const session = (0, initSession_1.initSession)(this.configurationName, redirectUri);
                    session.setSessionState(sessionState);
                    const items = yield session.loadItemsAsync();
                    storage = new memoryStorageBackend.MemoryStorageBackend(session.saveItemsAsync, items);
                    nonceData = yield session.getNonceAsync();
                }
                return new Promise((resolve, reject) => {
                    let queryStringUtil = new noHashQueryStringUtils.NoHashQueryStringUtils();
                    if (redirectUri.includes('#')) {
                        const splithash = window.location.href.split('#');
                        if (splithash.length === 2 && splithash[1].includes('?')) {
                            queryStringUtil = new noHashQueryStringUtils.HashQueryStringUtils();
                        }
                    }
                    const authorizationHandler = new built.RedirectRequestHandler(storage, queryStringUtil, window.location, new built.DefaultCrypto());
                    const notifier = new built.AuthorizationNotifier();
                    authorizationHandler.setAuthorizationNotifier(notifier);
                    notifier.setAuthorizationListener((request, response, error) => {
                        if (error) {
                            reject(error);
                            return;
                        }
                        if (!response) {
                            reject(new Error('no response'));
                            return;
                        }
                        let extras = null;
                        if (request && request.internal) {
                            extras = {};
                            extras.code_verifier = request.internal.code_verifier;
                            if (configuration.token_request_extras) {
                                for (const [key, value] of Object.entries(configuration.token_request_extras)) {
                                    extras[key] = value;
                                }
                            }
                        }
                        const tokenRequest = new built.TokenRequest({
                            client_id: clientId,
                            redirect_uri: redirectUri,
                            grant_type: built.GRANT_TYPE_AUTHORIZATION_CODE,
                            code: response.code,
                            refresh_token: undefined,
                            extras,
                        });
                        let timeoutId = setTimeout(() => {
                            reject(new Error('performTokenRequest timeout'));
                            timeoutId = null;
                        }, tokenRequestTimeout !== null && tokenRequestTimeout !== void 0 ? tokenRequestTimeout : 12000);
                        try {
                            const tokenHandler = new built.BaseTokenRequestHandler(new built.FetchRequestor());
                            tokenHandler.performTokenRequest(oidcServerConfiguration, tokenRequest).then((tokenResponse) => __awaiter(this, void 0, void 0, function* () {
                                if (timeoutId) {
                                    clearTimeout(timeoutId);
                                    this.timeoutId = null;
                                    const loginParams = getLoginParams(this.configurationName, redirectUri);
                                    let formattedTokens = null;
                                    if (serviceWorker) {
                                        const { tokens } = yield serviceWorker.initAsync(oidcServerConfiguration, 'syncTokensAsync', configuration);
                                        formattedTokens = tokens;
                                    }
                                    else {
                                        formattedTokens = (0, parseTokens.setTokens)(tokenResponse, null, configuration.token_renew_mode);
                                    }
                                    if (!(0, parseTokens.isTokensOidcValid)(formattedTokens, nonceData.nonce, oidcServerConfiguration)) {
                                        const exception = new Error('Tokens are not OpenID valid');
                                        if (timeoutId) {
                                            clearTimeout(timeoutId);
                                            this.timeoutId = null;
                                            this.publishEvent(eventNames.loginCallbackAsync_error, exception);
                                            console.error(exception);
                                            reject(exception);
                                        }
                                    }
                                    this.startCheckSessionAsync(oidcServerConfiguration.check_session_iframe, clientId, sessionState, isSilentSignin).then(() => {
                                        this.publishEvent(eventNames.loginCallbackAsync_end, {});
                                        resolve({
                                            tokens: formattedTokens,
                                            state: request.state,
                                            callbackPath: loginParams.callbackPath,
                                        });
                                    });
                                }
                            }));
                        }
                        catch (exception) {
                            if (timeoutId) {
                                clearTimeout(timeoutId);
                                this.timeoutId = null;
                                this.publishEvent(eventNames.loginCallbackAsync_error, exception);
                                console.error(exception);
                                reject(exception);
                            }
                        }
                    });
                    authorizationHandler.completeAuthorizationRequestIfPossible();
                });
            }
            catch (exception) {
                console.error(exception);
                this.publishEvent(eventNames.loginCallbackAsync_error, exception);
                throw exception;
            }
        });
    }
    synchroniseTokensAsync(refreshToken, index = 0, forceRefresh = false, extras = null, updateTokens) {
        return __awaiter(this, void 0, void 0, function* () {
            while (!navigator.onLine && document.hidden) {
                yield (0, initWorker.sleepAsync)(1000);
                this.publishEvent(eventNames.refreshTokensAsync, { message: 'wait because navigator is offline and hidden' });
            }
            let numberTryOnline = 6;
            while (!navigator.onLine && numberTryOnline > 0) {
                yield (0, initWorker.sleepAsync)(1000);
                numberTryOnline--;
                this.publishEvent(eventNames.refreshTokensAsync, { message: `wait because navigator is offline try ${numberTryOnline}` });
            }
            let numberTryHidden = Math.floor(Math.random() * 15) + 10;
            while (document.hidden && numberTryHidden > 0) {
                yield (0, initWorker.sleepAsync)(1000);
                numberTryHidden--;
                this.publishEvent(eventNames.refreshTokensAsync, { message: `wait because navigator is hidden try ${numberTryHidden}` });
            }
            const isDocumentHidden = document.hidden;
            const nextIndex = isDocumentHidden ? index : index + 1;
            if (!extras) {
                extras = {};
            }
            const configuration = this.configuration;
            const localsilentLoginAsync = () => __awaiter(this, void 0, void 0, function* () {
                try {
                    const loginParams = getLoginParams(this.configurationName, configuration.redirect_uri);
                    const silent_token_response = yield this.silentLoginAsync(Object.assign(Object.assign(Object.assign({}, loginParams.extras), extras), { prompt: 'none' }), loginParams.state);
                    if (silent_token_response) {
                        updateTokens(silent_token_response.tokens);
                        this.publishEvent(Oidc.eventNames.token_renewed, {});
                        return { tokens: silent_token_response.tokens, status: 'LOGGED' };
                    }
                }
                catch (exceptionSilent) {
                    console.error(exceptionSilent);
                    this.publishEvent(eventNames.refreshTokensAsync_silent_error, { message: 'exceptionSilent', exception: exceptionSilent.message });
                    if (exceptionSilent && exceptionSilent.message && exceptionSilent.message.startsWith('oidc')) {
                        updateTokens(null);
                        this.publishEvent(eventNames.refreshTokensAsync_error, { message: 'refresh token silent' });
                        return { tokens: null, status: 'SESSION_LOST' };
                    }
                }
                this.publishEvent(eventNames.refreshTokensAsync_error, { message: 'refresh token silent return' });
                return yield this.synchroniseTokensAsync(null, nextIndex, forceRefresh, extras, updateTokens);
            });
            if (index > 4) {
                this.publishEvent(eventNames.refreshTokensAsync_error, { message: 'refresh token' });
                return { tokens: null, status: 'SESSION_LOST' };
            }
            try {
                const { status, tokens, nonce } = yield this.syncTokensInfoAsync(configuration, this.configurationName, this.tokens, forceRefresh);
                switch (status) {
                    case 'SESSION_LOST':
                        updateTokens(null);
                        this.publishEvent(eventNames.refreshTokensAsync_error, { message: 'refresh token session lost' });
                        return { tokens: null, status: 'SESSION_LOST' };
                    case 'NOT_CONNECTED':
                        updateTokens(null);
                        return { tokens: null, status: null };
                    case 'TOKENS_VALID':
                        updateTokens(tokens);
                        return { tokens, status: 'LOGGED_IN' };
                    case 'TOKEN_UPDATED_BY_ANOTHER_TAB_TOKENS_VALID':
                        updateTokens(tokens);
                        this.publishEvent(Oidc.eventNames.token_renewed, { reason: 'TOKEN_UPDATED_BY_ANOTHER_TAB_TOKENS_VALID' });
                        return { tokens, status: 'LOGGED_IN' };
                    case 'LOGOUT_FROM_ANOTHER_TAB':
                        updateTokens(null);
                        this.publishEvent(eventNames.logout_from_another_tab, { status: 'session syncTokensAsync' });
                        return { tokens: null, status: 'LOGGED_OUT' };
                    case 'REQUIRE_SYNC_TOKENS':
                        this.publishEvent(eventNames.refreshTokensAsync_begin, { refreshToken, status, tryNumber: index });
                        return yield localsilentLoginAsync();
                    default: {
                        this.publishEvent(eventNames.refreshTokensAsync_begin, { refreshToken, status, tryNumber: index });
                        if (!refreshToken) {
                            return yield localsilentLoginAsync();
                        }
                        const clientId = configuration.client_id;
                        const redirectUri = configuration.redirect_uri;
                        const authority = configuration.authority;
                        const tokenExtras = configuration.token_request_extras ? configuration.token_request_extras : {};
                        const finalExtras = Object.assign(Object.assign({}, tokenExtras), extras);
                        const localFunctionAsync = () => __awaiter(this, void 0, void 0, function* () {
                            const details = {
                                client_id: clientId,
                                redirect_uri: redirectUri,
                                grant_type: built.GRANT_TYPE_REFRESH_TOKEN,
                                refresh_token: tokens.refreshToken,
                            };
                            const oidcServerConfiguration = yield this.initAsync(authority, configuration.authority_configuration);
                            const timeoutMs = document.hidden ? 10000 : 30000 * 10;
                            const tokenResponse = yield performTokenRequestAsync(oidcServerConfiguration.tokenEndpoint, details, finalExtras, tokens, configuration.token_renew_mode, timeoutMs);
                            if (tokenResponse.success) {
                                if (!(0, parseTokens.isTokensOidcValid)(tokenResponse.data, nonce.nonce, oidcServerConfiguration)) {
                                    updateTokens(null);
                                    this.publishEvent(eventNames.refreshTokensAsync_error, { message: 'refresh token return not valid tokens' });
                                    return { tokens: null, status: 'SESSION_LOST' };
                                }
                                updateTokens(tokenResponse.data);
                                this.publishEvent(eventNames.refreshTokensAsync_end, { success: tokenResponse.success });
                                this.publishEvent(Oidc.eventNames.token_renewed, { reason: 'REFRESH_TOKEN' });
                                return { tokens: tokenResponse.data, status: 'LOGGED_IN' };
                            }
                            else {
                                this.publishEvent(eventNames.refreshTokensAsync_silent_error, {
                                    message: 'bad request',
                                    tokenResponse,
                                });
                                return yield this.synchroniseTokensAsync(refreshToken, nextIndex, forceRefresh, extras, updateTokens);
                            }
                        });
                        // const promise =
                        return yield localFunctionAsync(); // executeWithTimeoutAsync(promise, 30000);
                    }
                }
            }
            catch (exception) {
                console.error(exception);
                this.publishEvent(eventNames.refreshTokensAsync_silent_error, { message: 'exception', exception: exception.message });
                return this.synchroniseTokensAsync(refreshToken, nextIndex, forceRefresh, extras, updateTokens);
            }
        });
    }
    syncTokensInfoAsync(configuration, configurationName, currentTokens, forceRefresh = false) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            // Service Worker can be killed by the browser (when it wants,for example after 10 seconds of inactivity, so we retreieve the session if it happen)
            // const configuration = this.configuration;
            const nullNonce = { nonce: null };
            if (!currentTokens) {
                return { tokens: null, status: 'NOT_CONNECTED', nonce: nullNonce };
            }
            let nonce = nullNonce;
            const oidcServerConfiguration = yield this.initAsync(configuration.authority, configuration.authority_configuration);
            const serviceWorker = yield (0, initWorker.initWorkerAsync)(configuration.service_worker_relative_url, configurationName, configuration.redirect_uri);
            if (serviceWorker) {
                const { status, tokens } = yield serviceWorker.initAsync(oidcServerConfiguration, 'syncTokensAsync', configuration);
                if (status === 'LOGGED_OUT') {
                    return { tokens: null, status: 'LOGOUT_FROM_ANOTHER_TAB', nonce: nullNonce };
                }
                else if (status === 'SESSIONS_LOST') {
                    return { tokens: null, status: 'SESSIONS_LOST', nonce: nullNonce };
                }
                else if (!status || !tokens) {
                    return { tokens: null, status: 'REQUIRE_SYNC_TOKENS', nonce: nullNonce };
                }
                else if (tokens.issuedAt !== currentTokens.issuedAt) {
                    const timeLeft = (0, parseTokens.computeTimeLeft)(configuration.refresh_time_before_tokens_expiration_in_second, tokens.expiresAt);
                    const status = (timeLeft > 0) ? 'TOKEN_UPDATED_BY_ANOTHER_TAB_TOKENS_VALID' : 'TOKEN_UPDATED_BY_ANOTHER_TAB_TOKENS_INVALID';
                    const nonce = yield serviceWorker.getNonceAsync();
                    return { tokens, status, nonce };
                }
                nonce = yield serviceWorker.getNonceAsync();
            }
            else {
                const session = (0, initSession_1.initSession)(configurationName, configuration.redirect_uri, (_a = configuration.storage) !== null && _a !== void 0 ? _a : sessionStorage);
                const { tokens, status } = yield session.initAsync();
                if (!tokens) {
                    return { tokens: null, status: 'LOGOUT_FROM_ANOTHER_TAB', nonce: nullNonce };
                }
                else if (status === 'SESSIONS_LOST') {
                    return { tokens: null, status: 'SESSIONS_LOST', nonce: nullNonce };
                }
                else if (tokens.issuedAt !== currentTokens.issuedAt) {
                    const timeLeft = (0, parseTokens.computeTimeLeft)(configuration.refresh_time_before_tokens_expiration_in_second, tokens.expiresAt);
                    const status = (timeLeft > 0) ? 'TOKEN_UPDATED_BY_ANOTHER_TAB_TOKENS_VALID' : 'TOKEN_UPDATED_BY_ANOTHER_TAB_TOKENS_INVALID';
                    const nonce = yield session.getNonceAsync();
                    return { tokens, status, nonce };
                }
                nonce = yield session.getNonceAsync();
            }
            const timeLeft = (0, parseTokens.computeTimeLeft)(configuration.refresh_time_before_tokens_expiration_in_second, currentTokens.expiresAt);
            const status = (timeLeft > 0) ? 'TOKENS_VALID' : 'TOKENS_INVALID';
            if (forceRefresh) {
                return { tokens: currentTokens, status: 'FORCE_REFRESH', nonce };
            }
            return { tokens: currentTokens, status, nonce };
        });
    }
    loginCallbackWithAutoTokensRenewAsync() {
        if (this.loginCallbackWithAutoTokensRenewPromise !== null) {
            return this.loginCallbackWithAutoTokensRenewPromise;
        }
        this.loginCallbackWithAutoTokensRenewPromise = loginCallbackWithAutoTokensRenewAsync(this);
        return this.loginCallbackWithAutoTokensRenewPromise.then(result => {
            this.loginCallbackWithAutoTokensRenewPromise = null;
            return result;
        });
    }
    userInfoAsync() {
        if (this.userInfoPromise !== null) {
            return this.userInfoPromise;
        }
        this.userInfoPromise = userInfoAsync(this);
        return this.userInfoPromise.then(result => {
            this.userInfoPromise = null;
            return result;
        });
    }
    renewTokensAsync(extras = null) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.timeoutId) {
                return;
            }
            timer_1$1.default.clearTimeout(this.timeoutId);
            // @ts-ignore
            yield renewTokensAndStartTimerAsync(this, this.tokens.refreshToken, true, extras);
        });
    }
    destroyAsync(status) {
        return __awaiter(this, void 0, void 0, function* () {
            timer_1$1.default.clearTimeout(this.timeoutId);
            this.timeoutId = null;
            if (this.checkSessionIFrame) {
                this.checkSessionIFrame.stop();
            }
            const serviceWorker = yield (0, initWorker.initWorkerAsync)(this.configuration.service_worker_relative_url, this.configurationName, this.configuration.redirect_uri);
            if (!serviceWorker) {
                const session = (0, initSession_1.initSession)(this.configurationName, this.configuration.redirect_uri, this.configuration.storage);
                yield session.clearAsync(status);
            }
            else {
                yield serviceWorker.clearAsync(status);
            }
            this.tokens = null;
            this.userInfo = null;
            // this.events = [];
        });
    }
    logoutSameTabAsync(clientId, sub) {
        return __awaiter(this, void 0, void 0, function* () {
            // @ts-ignore
            if (this.configuration.monitor_session && this.configuration.client_id === clientId && sub && this.tokens && this.tokens.idTokenPayload && this.tokens.idTokenPayload.sub === sub) {
                this.publishEvent(eventNames.logout_from_same_tab, { message: sub });
                yield this.destroyAsync('LOGGED_OUT');
            }
        });
    }
    logoutOtherTabAsync(clientId, sub) {
        return __awaiter(this, void 0, void 0, function* () {
            // @ts-ignore
            if (this.configuration.monitor_session && this.configuration.client_id === clientId && sub && this.tokens && this.tokens.idTokenPayload && this.tokens.idTokenPayload.sub === sub) {
                yield this.destroyAsync('LOGGED_OUT');
                this.publishEvent(eventNames.logout_from_another_tab, { message: 'SessionMonitor', sub });
            }
        });
    }
    logoutAsync(callbackPathOrUrl = undefined, extras = null) {
        return __awaiter(this, void 0, void 0, function* () {
            const configuration = this.configuration;
            const oidcServerConfiguration = yield this.initAsync(configuration.authority, configuration.authority_configuration);
            if (callbackPathOrUrl && (typeof callbackPathOrUrl !== 'string')) {
                callbackPathOrUrl = undefined;
                console.warn('callbackPathOrUrl path is not a string');
            }
            const path = (callbackPathOrUrl === null || callbackPathOrUrl === undefined) ? location.pathname + (location.search || '') + (location.hash || '') : callbackPathOrUrl;
            let isUri = false;
            if (callbackPathOrUrl) {
                isUri = callbackPathOrUrl.includes('https://') || callbackPathOrUrl.includes('http://');
            }
            const url = isUri ? callbackPathOrUrl : window.location.origin + path;
            // @ts-ignore
            const idToken = this.tokens ? this.tokens.idToken : '';
            try {
                const revocationEndpoint = oidcServerConfiguration.revocationEndpoint;
                if (revocationEndpoint) {
                    const promises = [];
                    if (this.tokens.accessToken) {
                        const revokeAccessTokenPromise = performRevocationRequestAsync(revocationEndpoint, this.tokens.accessToken, TOKEN_TYPE.access_token, configuration.client_id);
                        promises.push(revokeAccessTokenPromise);
                    }
                    if (this.tokens.refreshToken) {
                        const revokeRefreshTokenPromise = performRevocationRequestAsync(revocationEndpoint, this.tokens.refreshToken, TOKEN_TYPE.refresh_token, configuration.client_id);
                        promises.push(revokeRefreshTokenPromise);
                    }
                    if (promises.length > 0) {
                        yield Promise.all(promises);
                    }
                }
            }
            catch (exception) {
                console.warn(exception);
            }
            // @ts-ignore
            const sub = this.tokens && this.tokens.idTokenPayload ? this.tokens.idTokenPayload.sub : null;
            yield this.destroyAsync('LOGGED_OUT');
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            for (const [key, oidc] of Object.entries(oidcDatabase)) {
                if (oidc !== this) {
                    // @ts-ignore
                    yield oidc.logoutSameTabAsync(this.configuration.client_id, sub);
                }
            }
            if (oidcServerConfiguration.endSessionEndpoint) {
                if (!extras) {
                    extras = {
                        id_token_hint: idToken,
                    };
                    if (callbackPathOrUrl !== null) {
                        extras.post_logout_redirect_uri = url;
                    }
                }
                let queryString = '';
                if (extras) {
                    for (const [key, value] of Object.entries(extras)) {
                        if (queryString === '') {
                            queryString += '?';
                        }
                        else {
                            queryString += '&';
                        }
                        queryString += `${key}=${encodeURIComponent(value)}`;
                    }
                }
                window.location.href = `${oidcServerConfiguration.endSessionEndpoint}${queryString}`;
            }
            else {
                window.location.reload();
            }
        });
    }
}
exports.Oidc = Oidc;
Oidc.eventNames = eventNames;
exports.default = Oidc;

});

var vanillaOidc = createCommonjsModule(function (module, exports) {
var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VanillaOidc = void 0;


class VanillaOidc {
    constructor(oidc) {
        this._oidc = oidc;
    }
    subscribeEvents(func) {
        return this._oidc.subscribeEvents(func);
    }
    removeEventSubscription(id) {
        this._oidc.removeEventSubscription(id);
    }
    publishEvent(eventName, data) {
        this._oidc.publishEvent(eventName, data);
    }
    static getOrCreate(configuration, name = 'default') {
        return new VanillaOidc(oidc_1.Oidc.getOrCreate(configuration, name));
    }
    static get(name = 'default') {
        return new VanillaOidc(oidc_1.Oidc.get(name));
    }
    tryKeepExistingSessionAsync() {
        return this._oidc.tryKeepExistingSessionAsync();
    }
    loginAsync(callbackPath = undefined, extras = null, isSilentSignin = false, scope = undefined, silentLoginOnly = false) {
        return this._oidc.loginAsync(callbackPath, extras, isSilentSignin, scope, silentLoginOnly);
    }
    logoutAsync(callbackPathOrUrl = undefined, extras = null) {
        return this._oidc.logoutAsync(callbackPathOrUrl, extras);
    }
    silentLoginCallbackAsync() {
        return this._oidc.silentLoginCallbackAsync();
    }
    renewTokensAsync(extras = null) {
        return this._oidc.renewTokensAsync(extras);
    }
    loginCallbackAsync() {
        return this._oidc.loginCallbackWithAutoTokensRenewAsync();
    }
    get tokens() {
        return this._oidc.tokens;
    }
    get configuration() {
        return this._oidc.configuration;
    }
    getValidTokenAsync(waitMs = 200, numberWait = 50) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, parseTokens.getValidTokenAsync)(this._oidc, waitMs, numberWait);
        });
    }
    userInfoAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            return this._oidc.userInfoAsync();
        });
    }
}
exports.VanillaOidc = VanillaOidc;
VanillaOidc.eventNames = oidc_1.Oidc.eventNames;

});

var FetchToken = createCommonjsModule(function (module, exports) {
var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOidcFetch = exports.withOidcFetch = void 0;


const defaultConfigurationName = 'default';
const fetchWithToken = (fetch, getOidcWithConfigurationName) => (...params) => __awaiter(void 0, void 0, void 0, function* () {
    const [url, options, ...rest] = params;
    const optionTmp = options ? Object.assign({}, options) : { method: 'GET' };
    let headers = new Headers();
    if (optionTmp.headers) {
        headers = !(optionTmp.headers instanceof Headers)
            ? new Headers(optionTmp.headers)
            : optionTmp.headers;
    }
    const oidc = getOidcWithConfigurationName();
    // @ts-ignore
    const getValidToken = yield oidc.getValidTokenAsync();
    const accessToken = getValidToken.tokens.accessToken;
    if (!headers.has('Accept')) {
        headers.set('Accept', 'application/json');
    }
    if (accessToken) {
        headers.set('Authorization', `Bearer ${accessToken}`);
        if (!optionTmp.credentials) {
            optionTmp.credentials = 'same-origin';
        }
    }
    const newOptions = Object.assign(Object.assign({}, optionTmp), { headers });
    return yield fetch(url, newOptions, ...rest);
});
const withOidcFetch = (fetch = null, configurationName = defaultConfigurationName) => (WrappedComponent) => (props) => {
    const { fetch: newFetch } = (0, exports.useOidcFetch)(fetch || props.fetch, configurationName);
    return (0, jsx_runtime_1.jsx)(WrappedComponent, Object.assign({}, props, { fetch: newFetch }));
};
exports.withOidcFetch = withOidcFetch;
const useOidcFetch = (fetch = null, configurationName = defaultConfigurationName) => {
    const previousFetch = fetch || window.fetch;
    const getOidc = vanillaOidc.VanillaOidc.get;
    const getOidcWithConfigurationName = () => getOidc(configurationName);
    const newFetch = fetchWithToken(previousFetch, getOidcWithConfigurationName);
    return { fetch: newFetch };
};
exports.useOidcFetch = useOidcFetch;

});

var AuthenticateError_component = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

const AuthenticatingError = () => ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "oidc-authenticating" }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "oidc-authenticating__container" }, { children: [(0, jsx_runtime_1.jsx)("h1", Object.assign({ className: "oidc-authenticating__title" }, { children: "Error authentication" })), (0, jsx_runtime_1.jsx)("p", Object.assign({ className: "oidc-authenticating__content" }, { children: "An error occurred during authentication." }))] })) })));
exports.default = AuthenticatingError;

});

var Authenticating_component = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

const Authenticating = () => ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "oidc-authenticating" }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "oidc-authenticating__container" }, { children: [(0, jsx_runtime_1.jsx)("h1", Object.assign({ className: "oidc-authenticating__title" }, { children: "Authentication in progress" })), (0, jsx_runtime_1.jsx)("p", Object.assign({ className: "oidc-authenticating__content" }, { children: "You will be redirected to the login page." }))] })) })));
exports.default = Authenticating;

});

var withRouter = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCustomHistory = exports.CreateEvent = void 0;
const generateKey = () => Math.random()
    .toString(36)
    .substr(2, 6);
// IE Polyfill for CustomEvent
const CreateEvent = (windowInternal, documentInternal) => (event, params) => {
    if (typeof windowInternal.CustomEvent === 'function') {
        return new windowInternal.CustomEvent(event, params);
    }
    const paramsToFunction = params || { bubbles: false, cancelable: false, detail: undefined };
    const evt = documentInternal.createEvent('CustomEvent');
    evt.initCustomEvent(event, paramsToFunction.bubbles, paramsToFunction.cancelable, paramsToFunction.detail);
    evt.prototype = windowInternal.Event.prototype;
    return evt;
};
exports.CreateEvent = CreateEvent;
const getHistory = (windowInternal, CreateEventInternal, generateKeyInternal) => {
    return {
        replaceState: (url, stateHistory) => {
            const key = generateKeyInternal();
            const state = stateHistory || windowInternal.history.state;
            windowInternal.history.replaceState({ key, state }, null, url);
            windowInternal.dispatchEvent(CreateEventInternal('popstate'));
        },
    };
};
const getCustomHistory = () => getHistory(window, (0, exports.CreateEvent)(window, document), generateKey);
exports.getCustomHistory = getCustomHistory;

});

var Callback_component = createCommonjsModule(function (module, exports) {
var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CallBackSuccess = void 0;




const AuthenticateError_component_1 = __importDefault(AuthenticateError_component);
const CallBackSuccess = () => ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "oidc-callback" }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "oidc-callback__container" }, { children: [(0, jsx_runtime_1.jsx)("h1", Object.assign({ className: "oidc-callback__title" }, { children: "Authentication complete" })), (0, jsx_runtime_1.jsx)("p", Object.assign({ className: "oidc-callback__content" }, { children: "You will be redirected to your application." }))] })) })));
exports.CallBackSuccess = CallBackSuccess;
const CallbackManager = ({ callBackError, callBackSuccess, configurationName, withCustomHistory }) => {
    const [isError, setIsError] = (0, React.useState)(false);
    (0, React.useEffect)(() => {
        let isMounted = true;
        const playCallbackAsync = () => __awaiter(void 0, void 0, void 0, function* () {
            const getOidc = vanillaOidc.VanillaOidc.get;
            try {
                const { callbackPath } = yield getOidc(configurationName).loginCallbackAsync();
                const history = (withCustomHistory) ? withCustomHistory() : (0, withRouter.getCustomHistory)();
                history.replaceState(callbackPath || '/');
            }
            catch (error) {
                if (isMounted) {
                    setIsError(true);
                }
            }
        });
        playCallbackAsync();
        return () => {
            isMounted = false;
        };
    }, []);
    const CallbackErrorComponent = callBackError || AuthenticateError_component_1.default;
    const CallbackSuccessComponent = callBackSuccess || exports.CallBackSuccess;
    if (isError) {
        return (0, jsx_runtime_1.jsx)(CallbackErrorComponent, { configurationName: configurationName });
    }
    return (0, jsx_runtime_1.jsx)(CallbackSuccessComponent, { configurationName: configurationName });
};
exports.default = CallbackManager;

});

var Loading_component = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

const Loading = () => ((0, jsx_runtime_1.jsx)("span", Object.assign({ className: "oidc-loading" }, { children: "Loading" })));
exports.default = Loading;

});

var ServiceWorkerNotSupported_component = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

const ServiceWorkerNotSupported = () => ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "oidc-serviceworker" }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "oidc-serviceworker__container" }, { children: [(0, jsx_runtime_1.jsx)("h1", Object.assign({ className: "oidc-serviceworker__title" }, { children: "Unable to authenticate on this browser" })), (0, jsx_runtime_1.jsx)("p", Object.assign({ className: "oidc-serviceworker__content" }, { children: "Your browser is not secure enough to make authentication work. Try updating your browser or use a newer browser." }))] })) })));
exports.default = ServiceWorkerNotSupported;

});

var SessionLost_component = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionLost = void 0;

const SessionLost = () => ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "oidc-session-lost" }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "oidc-session-lost__container" }, { children: [(0, jsx_runtime_1.jsx)("h1", Object.assign({ className: "oidc-session-lost__title" }, { children: "Session timed out" })), (0, jsx_runtime_1.jsx)("p", Object.assign({ className: "oidc-session-lost__content" }, { children: "Your session has expired. Please re-authenticate." }))] })) })));
exports.SessionLost = SessionLost;
exports.default = exports.SessionLost;

});

var defaultComponent = createCommonjsModule(function (module, exports) {
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionLost = exports.ServiceWorkerNotSupported = exports.Loading = exports.CallBackSuccess = exports.Callback = exports.Authenticating = exports.AuthenticateError = void 0;

Object.defineProperty(exports, "AuthenticateError", { enumerable: true, get: function () { return __importDefault(AuthenticateError_component).default; } });

Object.defineProperty(exports, "Authenticating", { enumerable: true, get: function () { return __importDefault(Authenticating_component).default; } });

Object.defineProperty(exports, "Callback", { enumerable: true, get: function () { return __importDefault(Callback_component).default; } });
Object.defineProperty(exports, "CallBackSuccess", { enumerable: true, get: function () { return Callback_component.CallBackSuccess; } });

Object.defineProperty(exports, "Loading", { enumerable: true, get: function () { return __importDefault(Loading_component).default; } });

Object.defineProperty(exports, "ServiceWorkerNotSupported", { enumerable: true, get: function () { return __importDefault(ServiceWorkerNotSupported_component).default; } });

Object.defineProperty(exports, "SessionLost", { enumerable: true, get: function () { return __importDefault(SessionLost_component).default; } });

});

var SilentCallback_component = createCommonjsModule(function (module, exports) {
var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });



const SilentCallbackManager = ({ configurationName }) => {
    (0, React.useEffect)(() => {
        const playCallbackAsync = () => __awaiter(void 0, void 0, void 0, function* () {
            const getOidc = vanillaOidc.VanillaOidc.get;
            const oidc = getOidc(configurationName);
            oidc.silentLoginCallbackAsync();
        });
        playCallbackAsync();
    }, []);
    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
};
exports.default = SilentCallbackManager;

});

var SilentLogin_component = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });




const SilentLogin = ({ configurationName }) => {
    const queryParams = (0, routeUtils.getParseQueryStringFromLocation)(window.location.href);
    const getOidc = vanillaOidc.VanillaOidc.get;
    const oidc = getOidc(configurationName);
    let extras = null;
    for (const [key, value] of Object.entries(queryParams)) {
        if (key === 'state' || key === 'scope') {
            continue;
        }
        if (extras === null) {
            extras = {};
        }
        extras[key] = value;
    }
    (0, React.useEffect)(() => {
        if (!oidc.tokens) {
            oidc.loginAsync(null, extras, true, queryParams.scope);
        }
    }, []);
    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
};
exports.default = SilentLogin;

});

var OidcRoutes_1 = createCommonjsModule(function (module, exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });

const react_1 = __importStar(React);

const Callback_component_1 = __importDefault(Callback_component);
const SilentCallback_component_1 = __importDefault(SilentCallback_component);
const SilentLogin_component_1 = __importDefault(SilentLogin_component);
const defaultProps = {};
const OidcRoutes = ({ callbackErrorComponent, callbackSuccessComponent, redirect_uri, silent_redirect_uri, silent_login_uri, children, configurationName, withCustomHistory = null, }) => {
    // This exist because in next.js window outside useEffect is null
    const pathname = window ? (0, routeUtils.getPath)(window.location.href) : '';
    const [path, setPath] = (0, react_1.useState)(pathname);
    (0, react_1.useEffect)(() => {
        const setNewPath = () => setPath((0, routeUtils.getPath)(window.location.href));
        setNewPath();
        window.addEventListener('popstate', setNewPath, false);
        return () => window.removeEventListener('popstate', setNewPath, false);
    }, []);
    const callbackPath = (0, routeUtils.getPath)(redirect_uri);
    if (silent_redirect_uri) {
        if (path === (0, routeUtils.getPath)(silent_redirect_uri)) {
            return (0, jsx_runtime_1.jsx)(SilentCallback_component_1.default, { configurationName: configurationName });
        }
    }
    if (silent_login_uri) {
        if (path === (0, routeUtils.getPath)(silent_login_uri)) {
            return (0, jsx_runtime_1.jsx)(SilentLogin_component_1.default, { configurationName: configurationName });
        }
    }
    switch (path) {
        case callbackPath:
            return (0, jsx_runtime_1.jsx)(Callback_component_1.default, { callBackError: callbackErrorComponent, callBackSuccess: callbackSuccessComponent, configurationName: configurationName, withCustomHistory: withCustomHistory });
        default:
            return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: children });
    }
};
// @ts-ignore
OidcRoutes.defaultProps = defaultProps;
exports.default = react_1.default.memo(OidcRoutes);

});

var OidcProvider_1 = createCommonjsModule(function (module, exports) {
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OidcProvider = void 0;


const AuthenticateError_component_1 = __importDefault(AuthenticateError_component);

const ServiceWorkerNotSupported_component_1 = __importDefault(ServiceWorkerNotSupported_component);
const OidcRoutes_1$1 = __importDefault(OidcRoutes_1);

const defaultEventState = { name: '', data: null };
const OidcSession = ({ loadingComponent, children, configurationName }) => {
    const [isLoading, setIsLoading] = (0, React.useState)(true);
    const getOidc = vanillaOidc.VanillaOidc.get;
    const oidc = getOidc(configurationName);
    (0, React.useEffect)(() => {
        let isMounted = true;
        if (oidc) {
            oidc.tryKeepExistingSessionAsync().then(() => {
                if (isMounted) {
                    setIsLoading(false);
                }
            });
        }
        return () => {
            isMounted = false;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [configurationName]);
    const LoadingComponent = loadingComponent;
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: isLoading
            ? ((0, jsx_runtime_1.jsx)(LoadingComponent, { configurationName: configurationName }))
            : ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: children })) }));
};
const Switch = ({ isLoading, loadingComponent, children, configurationName }) => {
    const LoadingComponent = loadingComponent;
    if (isLoading) {
        return (0, jsx_runtime_1.jsx)(LoadingComponent, Object.assign({ configurationName: configurationName }, { children: children }));
    }
    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: children });
};
const OidcProvider = ({ children, configuration, configurationName = 'default', callbackSuccessComponent = defaultComponent.CallBackSuccess, authenticatingComponent = defaultComponent.Authenticating, loadingComponent = defaultComponent.Loading, serviceWorkerNotSupportedComponent = ServiceWorkerNotSupported_component_1.default, authenticatingErrorComponent = AuthenticateError_component_1.default, sessionLostComponent = defaultComponent.SessionLost, onSessionLost = null, onLogoutFromAnotherTab = null, onLogoutFromSameTab = null, withCustomHistory = null, onEvent = null, }) => {
    const getOidc = (configurationName = 'default') => {
        return vanillaOidc.VanillaOidc.getOrCreate(configuration, configurationName);
    };
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const [loading, setLoading] = (0, React.useState)(true);
    const [event, setEvent] = (0, React.useState)(defaultEventState);
    const [currentConfigurationName, setConfigurationName] = (0, React.useState)('default');
    (0, React.useEffect)(() => {
        const oidc = getOidc(configurationName);
        const newSubscriptionId = oidc.subscribeEvents((name, data) => {
            if (onEvent) {
                onEvent(configurationName, name, data);
            }
        });
        return () => {
            const previousOidc = getOidc(configurationName);
            previousOidc.removeEventSubscription(newSubscriptionId);
        };
    }, [configurationName, onEvent]);
    (0, React.useEffect)(() => {
        const oidc = getOidc(configurationName);
        const newSubscriptionId = oidc.subscribeEvents((name, data) => {
            if (name === vanillaOidc.VanillaOidc.eventNames.refreshTokensAsync_error || name === vanillaOidc.VanillaOidc.eventNames.syncTokensAsync_error) {
                if (onSessionLost != null) {
                    onSessionLost();
                    return;
                }
                setEvent({ name, data });
            }
            else if (name === vanillaOidc.VanillaOidc.eventNames.logout_from_another_tab) {
                if (onLogoutFromAnotherTab != null) {
                    onLogoutFromAnotherTab();
                    return;
                }
                setEvent({ name, data });
            }
            else if (name === vanillaOidc.VanillaOidc.eventNames.logout_from_same_tab) {
                if (onLogoutFromSameTab != null) {
                    onLogoutFromSameTab();
                }
                // setEvent({name, data});
            }
            else if (name === vanillaOidc.VanillaOidc.eventNames.loginAsync_begin ||
                name === vanillaOidc.VanillaOidc.eventNames.loginCallbackAsync_end ||
                name === vanillaOidc.VanillaOidc.eventNames.loginAsync_error ||
                name === vanillaOidc.VanillaOidc.eventNames.loginCallbackAsync_error) {
                setEvent({ name, data });
            }
            else if (name === vanillaOidc.VanillaOidc.eventNames.service_worker_not_supported_by_browser && configuration.service_worker_only === true) {
                setEvent({ name, data });
            }
        });
        setConfigurationName(configurationName);
        setLoading(false);
        return () => {
            const previousOidc = getOidc(configurationName);
            previousOidc.removeEventSubscription(newSubscriptionId);
            setEvent(defaultEventState);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [configuration, configurationName]);
    const SessionLostComponent = sessionLostComponent;
    const AuthenticatingComponent = authenticatingComponent;
    const LoadingComponent = loadingComponent;
    const ServiceWorkerNotSupportedComponent = serviceWorkerNotSupportedComponent;
    const AuthenticatingErrorComponent = authenticatingErrorComponent;
    const isLoading = (loading || (currentConfigurationName !== configurationName));
    const oidc = getOidc(configurationName);
    const eventName = event.name;
    switch (eventName) {
        case vanillaOidc.VanillaOidc.eventNames.service_worker_not_supported_by_browser:
            return ((0, jsx_runtime_1.jsx)(Switch, Object.assign({ loadingComponent: LoadingComponent, isLoading: isLoading, configurationName: configurationName }, { children: (0, jsx_runtime_1.jsx)(ServiceWorkerNotSupportedComponent, { configurationName: configurationName }) })));
        case vanillaOidc.VanillaOidc.eventNames.loginAsync_begin:
            return ((0, jsx_runtime_1.jsx)(Switch, Object.assign({ loadingComponent: LoadingComponent, isLoading: isLoading, configurationName: configurationName }, { children: (0, jsx_runtime_1.jsx)(AuthenticatingComponent, { configurationName: configurationName }) })));
        case vanillaOidc.VanillaOidc.eventNames.loginAsync_error:
        case vanillaOidc.VanillaOidc.eventNames.loginCallbackAsync_error:
            return ((0, jsx_runtime_1.jsx)(Switch, Object.assign({ loadingComponent: LoadingComponent, isLoading: isLoading, configurationName: configurationName }, { children: (0, jsx_runtime_1.jsx)(AuthenticatingErrorComponent, { configurationName: configurationName }) })));
        case vanillaOidc.VanillaOidc.eventNames.refreshTokensAsync_error:
        case vanillaOidc.VanillaOidc.eventNames.syncTokensAsync_error:
        case vanillaOidc.VanillaOidc.eventNames.logout_from_another_tab:
            return ((0, jsx_runtime_1.jsx)(Switch, Object.assign({ loadingComponent: LoadingComponent, isLoading: isLoading, configurationName: configurationName }, { children: (0, jsx_runtime_1.jsx)(SessionLostComponent, { configurationName: configurationName }) })));
        default:
            return ((0, jsx_runtime_1.jsx)(Switch, Object.assign({ loadingComponent: LoadingComponent, isLoading: isLoading, configurationName: configurationName }, { children: (0, jsx_runtime_1.jsx)(OidcRoutes_1$1.default, Object.assign({ redirect_uri: oidc.configuration.redirect_uri, silent_redirect_uri: oidc.configuration.silent_redirect_uri, silent_login_uri: oidc.configuration.silent_login_uri, callbackSuccessComponent: callbackSuccessComponent, callbackErrorComponent: authenticatingErrorComponent, authenticatingComponent: authenticatingComponent, configurationName: configurationName, withCustomHistory: withCustomHistory }, { children: (0, jsx_runtime_1.jsx)(OidcSession, Object.assign({ loadingComponent: LoadingComponent, configurationName: configurationName }, { children: children })) })) })));
    }
};
exports.OidcProvider = OidcProvider;
exports.default = exports.OidcProvider;

});

var OidcSecure_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.withOidcSecure = exports.OidcSecure = void 0;



const OidcSecure = ({ children, callbackPath = null, extras = null, configurationName = 'default' }) => {
    const getOidc = vanillaOidc.VanillaOidc.get;
    const oidc = getOidc(configurationName);
    (0, React.useEffect)(() => {
        if (!oidc.tokens) {
            oidc.loginAsync(callbackPath, extras);
        }
    }, [configurationName, callbackPath, extras]);
    if (!oidc.tokens) {
        return null;
    }
    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: children });
};
exports.OidcSecure = OidcSecure;
const withOidcSecure = (WrappedComponent, callbackPath = null, extras = null, configurationName = 'default') => (props) => {
    return (0, jsx_runtime_1.jsx)(exports.OidcSecure, Object.assign({ callbackPath: callbackPath, extras: extras, configurationName: configurationName }, { children: (0, jsx_runtime_1.jsx)(WrappedComponent, Object.assign({}, props)) }));
};
exports.withOidcSecure = withOidcSecure;

});

var ReactOidc = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOidcIdToken = exports.useOidcAccessToken = exports.useOidc = void 0;


const defaultConfigurationName = 'default';
const defaultIsAuthenticated = (getOidc, configurationName) => {
    let isAuthenticated = false;
    const oidc = getOidc(configurationName);
    if (oidc) {
        isAuthenticated = getOidc(configurationName).tokens != null;
    }
    return isAuthenticated;
};
const useOidc = (configurationName = defaultConfigurationName) => {
    const getOidc = vanillaOidc.VanillaOidc.get;
    const [isAuthenticated, setIsAuthenticated] = (0, React.useState)(defaultIsAuthenticated(getOidc, configurationName));
    (0, React.useEffect)(() => {
        let isMounted = true;
        const oidc = getOidc(configurationName);
        setIsAuthenticated(defaultIsAuthenticated(getOidc, configurationName));
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const newSubscriptionId = oidc.subscribeEvents((name, data) => {
            if (name === vanillaOidc.VanillaOidc.eventNames.logout_from_another_tab || name === vanillaOidc.VanillaOidc.eventNames.logout_from_same_tab || name === vanillaOidc.VanillaOidc.eventNames.token_aquired) {
                if (isMounted) {
                    setIsAuthenticated(defaultIsAuthenticated(getOidc, configurationName));
                }
            }
        });
        return () => {
            isMounted = false;
            oidc.removeEventSubscription(newSubscriptionId);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [configurationName]);
    const login = (callbackPath = undefined, extras = null, silentLoginOnly = false) => {
        return getOidc(configurationName).loginAsync(callbackPath, extras, false, undefined, silentLoginOnly);
    };
    const logout = (callbackPath = undefined, extras = null) => {
        return getOidc(configurationName).logoutAsync(callbackPath, extras);
    };
    const renewTokens = (extras = null) => {
        return getOidc(configurationName).renewTokensAsync(extras);
    };
    return { login, logout, renewTokens, isAuthenticated };
};
exports.useOidc = useOidc;
const accessTokenInitialState = { accessToken: null, accessTokenPayload: null };
const initTokens = (configurationName) => {
    const getOidc = vanillaOidc.VanillaOidc.get;
    const oidc = getOidc(configurationName);
    if (oidc.tokens) {
        const tokens = oidc.tokens;
        return { accessToken: tokens.accessToken, accessTokenPayload: tokens.accessTokenPayload };
    }
    return accessTokenInitialState;
};
const useOidcAccessToken = (configurationName = defaultConfigurationName) => {
    const getOidc = vanillaOidc.VanillaOidc.get;
    const [state, setAccessToken] = (0, React.useState)(initTokens(configurationName));
    (0, React.useEffect)(() => {
        let isMounted = true;
        const oidc = getOidc(configurationName);
        if (oidc.tokens) {
            const tokens = oidc.tokens;
            setAccessToken({ accessToken: tokens.accessToken, accessTokenPayload: tokens.accessTokenPayload });
        }
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const newSubscriptionId = oidc.subscribeEvents((name, data) => {
            if (name === vanillaOidc.VanillaOidc.eventNames.token_renewed ||
                name === vanillaOidc.VanillaOidc.eventNames.token_aquired ||
                name === vanillaOidc.VanillaOidc.eventNames.logout_from_another_tab ||
                name === vanillaOidc.VanillaOidc.eventNames.logout_from_same_tab ||
                name === vanillaOidc.VanillaOidc.eventNames.refreshTokensAsync_error ||
                name === vanillaOidc.VanillaOidc.eventNames.syncTokensAsync_error) {
                if (isMounted) {
                    const tokens = oidc.tokens;
                    setAccessToken(tokens != null ? { accessToken: tokens.accessToken, accessTokenPayload: tokens.accessTokenPayload } : accessTokenInitialState);
                }
            }
        });
        return () => {
            isMounted = false;
            oidc.removeEventSubscription(newSubscriptionId);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [configurationName]);
    return state;
};
exports.useOidcAccessToken = useOidcAccessToken;
const idTokenInitialState = { idToken: null, idTokenPayload: null };
const initIdToken = (configurationName) => {
    const getOidc = vanillaOidc.VanillaOidc.get;
    const oidc = getOidc(configurationName);
    if (oidc.tokens) {
        const tokens = oidc.tokens;
        return { idToken: tokens.idToken, idTokenPayload: tokens.idTokenPayload };
    }
    return idTokenInitialState;
};
const useOidcIdToken = (configurationName = defaultConfigurationName) => {
    const getOidc = vanillaOidc.VanillaOidc.get;
    const [state, setIDToken] = (0, React.useState)(initIdToken(configurationName));
    (0, React.useEffect)(() => {
        let isMounted = true;
        const oidc = getOidc(configurationName);
        if (oidc.tokens) {
            const tokens = oidc.tokens;
            setIDToken({ idToken: tokens.idToken, idTokenPayload: tokens.idTokenPayload });
        }
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const newSubscriptionId = oidc.subscribeEvents((name, data) => {
            if (name === vanillaOidc.VanillaOidc.eventNames.token_renewed ||
                name === vanillaOidc.VanillaOidc.eventNames.token_aquired ||
                name === vanillaOidc.VanillaOidc.eventNames.logout_from_another_tab ||
                name === vanillaOidc.VanillaOidc.eventNames.logout_from_same_tab ||
                name === vanillaOidc.VanillaOidc.eventNames.refreshTokensAsync_error ||
                name === vanillaOidc.VanillaOidc.eventNames.syncTokensAsync_error) {
                if (isMounted) {
                    const tokens = oidc.tokens;
                    setIDToken(tokens != null ? { idToken: tokens.idToken, idTokenPayload: tokens.idTokenPayload } : idTokenInitialState);
                }
            }
        });
        return () => {
            isMounted = false;
            oidc.removeEventSubscription(newSubscriptionId);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [configurationName]);
    return state;
};
exports.useOidcIdToken = useOidcIdToken;

});

var User = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOidcUser = exports.OidcUserStatus = void 0;


var OidcUserStatus;
(function (OidcUserStatus) {
    OidcUserStatus["Unauthenticated"] = "Unauthenticated";
    OidcUserStatus["Loading"] = "Loading user";
    OidcUserStatus["Loaded"] = "User loaded";
    OidcUserStatus["LoadingError"] = "Error loading user";
})(OidcUserStatus = exports.OidcUserStatus || (exports.OidcUserStatus = {}));
const useOidcUser = (configurationName = 'default') => {
    const [oidcUser, setOidcUser] = (0, React.useState)({ user: null, status: OidcUserStatus.Unauthenticated });
    const oidc = vanillaOidc.VanillaOidc.get(configurationName);
    (0, React.useEffect)(() => {
        let isMounted = true;
        if (oidc && oidc.tokens) {
            setOidcUser(Object.assign(Object.assign({}, oidcUser), { status: OidcUserStatus.Loading }));
            oidc.userInfoAsync()
                .then((info) => {
                if (isMounted) {
                    setOidcUser({ user: info, status: OidcUserStatus.Loaded });
                }
            })
                .catch(() => setOidcUser(Object.assign(Object.assign({}, oidcUser), { status: OidcUserStatus.LoadingError })));
        }
        return () => { isMounted = false; };
    }, []);
    return { oidcUser: oidcUser.user, oidcUserLoadingState: oidcUser.status };
};
exports.useOidcUser = useOidcUser;

});

var dist = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenRenewMode = exports.useOidcUser = exports.OidcUserStatus = exports.useOidcIdToken = exports.useOidcAccessToken = exports.useOidc = exports.withOidcSecure = exports.OidcSecure = exports.OidcProvider = exports.withOidcFetch = exports.useOidcFetch = void 0;

Object.defineProperty(exports, "useOidcFetch", { enumerable: true, get: function () { return FetchToken.useOidcFetch; } });
Object.defineProperty(exports, "withOidcFetch", { enumerable: true, get: function () { return FetchToken.withOidcFetch; } });

Object.defineProperty(exports, "OidcProvider", { enumerable: true, get: function () { return OidcProvider_1.OidcProvider; } });

Object.defineProperty(exports, "OidcSecure", { enumerable: true, get: function () { return OidcSecure_1.OidcSecure; } });
Object.defineProperty(exports, "withOidcSecure", { enumerable: true, get: function () { return OidcSecure_1.withOidcSecure; } });

Object.defineProperty(exports, "useOidc", { enumerable: true, get: function () { return ReactOidc.useOidc; } });
Object.defineProperty(exports, "useOidcAccessToken", { enumerable: true, get: function () { return ReactOidc.useOidcAccessToken; } });
Object.defineProperty(exports, "useOidcIdToken", { enumerable: true, get: function () { return ReactOidc.useOidcIdToken; } });

Object.defineProperty(exports, "OidcUserStatus", { enumerable: true, get: function () { return User.OidcUserStatus; } });
Object.defineProperty(exports, "useOidcUser", { enumerable: true, get: function () { return User.useOidcUser; } });

Object.defineProperty(exports, "TokenRenewMode", { enumerable: true, get: function () { return parseTokens.TokenRenewMode; } });

});

export { dist as d, oidc_1 as o };
